import { MoneyExchangeRate } from "../models/money-exchange-rate";

export const Constant = {
  // tslint:disable-next-line: max-line-length
  emailRegex:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
export const emptyFields = {
  NA: "N/A",
};
export const viewRecieptDetails = {
  name: 'FlexM Pvt Ltd',
  address: '16 Collyer Quay,<br> #13-01 Income@Raffles,<br> Singapore 049318',
  uen: '201207298R',
  telePhone: '1234567890',
  gstNo: 'xxxxxxxxxxxx'
}
export const appSettings = {
  Nationality: 'nationality',
  occupations: 'occupations',
  kyc_resident_type: 'kyc_resident_type',
  Address: 'receipt_address',
  onboardingDocument: "merchant_onboarding_documents",
  individualDocument: "merchant_individuals_documents",
  nonIndividualDocument: "merchant_entity_documents",
  provinceList: "merchant_hst"
};
export const NatureBusiness = [
  { value: 'Salaried', label: 'Salaried' },
  { value: 'Self-Employed', label: 'Self-Employed' },
  { value: 'Retired', label: 'Retired' },
  { value: 'Student', label: 'Student ' },
];
export const PepHio_options = [
  { value: 'No', label: "No", },
  { value: 'Local PEP', label: "Local PEP", },
  { value: 'Foreign PEP', label: "Foreign PEP", },
  { value: 'PEP associate or family', label: "PEP associate or family", }
];
export const ResidentType = [
  { value: 'Citizen', label: 'Citizen' },
  { value: 'Permanent Resident', label: 'Permanent Resident' },
  { value: 'Work Permit', label: 'Work Permit' },
  { value: 'Student Permit', label: 'Student Permit' },
];
export const debitAmountCode = {
  BankVerificationAmount: "bank_verification_amount"
}
export const offerTitle = {
  update: 'Update Offer',
  create: 'Create Offer'
}
export const Country = {
  alpha_2_code: "SG",
  alpha_3_code: "SGP",
  currency_code: "SGD",
  name: "Singapore",
  symbol: "$",
  countrySymbol: "SG$",
  telephone_code: "+65",
};
export const RiskParameterType = [
  { value: "numberRange", label: "Number Range" },
  { value: "keyPair", label: "Key Pair" },
  { value: "stringArray", label: "String Array" },
  { value: "string", label: "String" },
  { value: "number", label: "Number" },
]
export const CustomerRiskType = {
  String: "string",
  Number: "number",
  StringArray: "stringArray",
  NumberRange: "numberRange",
  KeyPair: "keyPair",
}
export const CustomerRiskControls = {
  DefaultProhibitedValues: 'defaultProhibitedRiskValues',
  DefaultHigh1RiskValues: 'defaultHigh1RiskValues',
  DefaultHigh2RiskValues: 'defaultHigh2RiskValues',
  DefaultHigh3RiskValues: 'defaultHigh3RiskValues',
  DefaultMediumRiskValues: 'defaultMediumRiskValues',
  DefaultLowRiskValues: 'defaultLowRiskValues',
  DefaultParameterID: 'defaultParameterId',
  Code: 'code'
}
export const CustomerTypes = {
  individual: "individual",
  business: "business",
};
export const CustomerTypesText = {
  individual: "Individual",
  business: "Business",
};
export const CustomerTypesColor = {
  individual: "magenta",
  business: "cyan",
};
export const CustomerType = [
  { value: "individual", label: "Individual" },
  { value: "business", label: "Business" }
]
export const recieverTypeOptions = [
  { value: 'merchant', label: 'Merchant' },
  { value: 'kyc-board-user', label: 'Compliance' },
];
export const kycStatusOptions = [
  // { value: 'All', label: 'All' },
  { value: "notsubmitted", label: "Not Submitted" },
  { value: "submitted", label: "Submitted" },
  // { value: 'awaiting', label: 'Awaiting' },
  { value: "underreview", label: "Under Review" },
  { value: "incomplete", label: "Incomplete" },
  { value: "verified", label: "Verified" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: 'expired', label: 'Expired' },
  { value: 'nearexpiry', label: 'Near Expiry' }

];
export const merchantDocumentStatusOptions = [
  // { value: 'All', label: 'All' },
  { value: "notsubmitted", label: "Not Submitted" },
  { value: "submitted", label: "Submitted" },
  { value: "incomplete", label: "Incomplete" },
  { value: "approved", label: "Approved" },
  { value: "reviewed", label: "Reviewed" },
];
export const kycStatusOptionsForOTPVerifiedUsers = [
  { value: "notsubmitted", label: "Not Submitted" },
  { value: "submitted", label: "Submitted" },
];
export const kycProviders = [{ value: "ONFIDO", label: "ONFIDO" }];
export const KycStatus = {
  verified: "verified",
  rejected: "rejected",
  approved: "approved",
  submitted: "submitted",
  notsubmitted: "notsubmitted",
  // resubmitted: "resubmitted",
  incomplete: "incomplete",
  underreview: "underreview",
  expired: "expired",
  nearExpiry: "nearexpiry",
  reviewed: "reviewed",
  awaiting: 'awaiting',
  dev2approved: 'dev2approved'

};
export const KycStatusIconTypeForSideMenu = {
  verified: 'check',
  rejected: 'close-circle',
  approved: 'check-circle',
  submitted: 'file-image',
  notsubmitted: 'info-circle',
  resubmitted: 'minus-circle',
  incomplete: 'exclamation-circle',
  underreview: 'down-circle',
  expired: 'clock-circle',
  nearExpiry: 'warning'
};
export const MerchantSettlementText = {
  merchantSettlement: 'Merchant Settlement',
  locationSettlement: 'Location Settlement'
};
export const MerchantSettlementColor = {
  merchantSettlement: 'magenta',
  locationSettlement: 'cyan'
}
export const AvailableColor = {
  true: 'green',
  false: 'red'
}
export const AssignedColor = {
  true: 'green',
  false: 'red'
}
export const KycStatusText = {
  verified: "Verified",
  rejected: "Rejected",
  approved: "Approved",
  submitted: "Submitted",
  notsubmitted: "Not Submitted",
  // resubmitted: "Re submitted",
  incomplete: "Incomplete",
  underreview: "Under Review",
  expired: "Expired",
  nearExpiry: "Near Expiry",
  reviewed: "Reviewed",
  awaiting: 'Awaiting',
  dev2approved: 'Dev2 Approved'

};
export const KycStatusColor = {
  verified: "magenta",
  rejected: "red",
  approved: "green",
  submitted: "cyan",
  notsubmitted: "blue",
  // resubmitted: "geekblue",
  incomplete: "purple",
  underreview: "orange",
  expired: "red",
  nearExpiry: "gold",
  reviewed: "orange",
  awaiting: 'orange',
  dev2approved: 'green'
};
export const ProductType = {
  Prepaid: 'prepaid',
  Postpaid: 'postpaid',
  GovernmentServices: 'government services',
  UtilityServices: 'utility services'
};
export const ProductTypeText = {
  Prepaid: "Prepaid",
  Postpaid: "PostPaid",
  GovernmentServices: "Government Services",
  UtilityServices: "Utility Services"
};
export const ProductTypeColor = {
  Prepaid: "blue",
  Postpaid: "cyan",
  GovernmentServices: "green",
  UtilityServices: "orange",
};
export const ProviderName = {
  Ayopop: 'Ayopop',
  Ventaja: 'Ventaja',
  billAvenue: 'billAvenue',
  ventajaUnified: 'ventajaUnified',
  DTOne: 'DTOne',
};
export const ProviderNameText = {
  Ayopop: 'Ayopop',
  Ventaja: 'Ventaja',
  billAvenue: 'Bill Avenue',
  ventajaUnified: 'Ventaja Unified',
  DTOne: 'DT One',
};
export const ProviderNameColor = {
  Ayopop: 'blue',
  Ventaja: 'cyan',
  billAvenue: 'orange',
  ventajaUnified: 'magenta',
  DTOne: 'yellow',
};

export const Tier = {
  tier1: 1,
  tier2: 2,
  tier3: 3,
};
export const TierName = {
  tier1: "Tier 1",
  tier2: "Tier 2",
  tier3: "Tier 3",
};
export const tagColorForTier = {
  tier1: "blue",
  tier2: "magenta",
  tier3: "green",
};
export const TierOptions = [
  { value: 1, label: "Tier 1" },
  { value: 2, label: "Tier 2" },
  { value: 3, label: "Tier 3" },
];
export const webPortalUserUrl = {
  admin: "admin-users-report",
  kyc: "kyc-users-report",
  merchant: "merchant-users-report",
  agent: "agent-users-report",
  remittance: "remittance-users-report",
};
export const UsersType = {
  admin: "admin",
  appUser: "appuser",
  merchantUser: "merchant",
  providerUser: "Provider",
  locationUser: "location-user",
  locationManager: "location-manager",
  agent: "agent",
  kycBoardUser: "kyc-board-user",
  businessUser: "business-user",
};
export const UsersTypeText = {
  admin: "Admin User",
  appUser: "App User",
  merchantUser: "Merchant User",
  locationUser: "Location User",
  locationManager: "Location Manager",
  agent: "Agent User",
  kycBoardUser: "KYC Board User",
};

export const tagColorForUserType = {
  admin: "purple",
  appUser: "green",
  merchantUser: "cyan",
  locationUser: "purple",
  locationManager: "blue",
  agent: "orange",
  kycBoardUser: "magenta",
};

export const adminUserTypeOptions = [
  { value: "admin", label: "ADMIN BOARD" },
  { value: "kyc-board-user", label: "KYC BOARD" },
];

export const merchantUserTypeOptions = [
  { value: "merchant", label: "Merchant User" },
  { value: "location-user", label: "Location User" },
  { value: "location-manager", label: "Location Manager" },
];

export const AllUserTypeOptions = [
  { value: "admin", label: "Admin" },
  { value: "finance", label: "Finance" },
  { value: "agent", label: "Agent" },
  { value: "merchant", label: "Merchant User" },
  { value: "location-user", label: "Location User" },
  { value: "location-manager", label: "Location Manager" },
];
export const typeOptions = [
  { value: 'Credit', label: "Credit" },
  { value: 'Debit', label: "Debit" }
]
export const TransactionType = {
  WalletCreate: 1,
  SendMoney: 2,
  AddMoney: 3,
  MerchantPay: 4, // 'Payment to Merchant'
  Credit: 5,
  Refund: 6,
  MerchantSettlement: 7,
  WalletUnload: 8,
  ExternalApiDebit: 9,
  TransferFee: 11,
  WalletClose: 12,
  Remittance: 13,
  AirtimeTopup: 14,
  BillPayment: 15,
  Prefund: 16,
  Issue: 17,
  AddFund: 21,
  ReturnFund: 22,
  Voucher: 18,
  MembershipPayment: 20,
  ClientRemittance: 23,
  SetupFees: 33,
  AddSetupFees: 34,
  SendMoneyByUEN: 35,
  SendMoneyByQR: 36,
  PaymentCollection: 37,
  PaymentSettlement: 38,
  AddMoneyCurrencyCloud: 39,
  SendMoneyCurrencyCloud: 40,
  SendMoneyTorkeyTime: 42,
  DirectRemittancePaymentReceived: 43,
  BulkUploadCrossBorderSendMoney: 44,
  Recovery: 45,
  BulkUploadDomesticSendMoney : 46
};


export const TransactionTypesText = {
  WalletCreate: "Wallet Create",
  SendMoney: "Send Money",
  AddMoney: "Add Money",
  MerchantPay: "Merchant Pay",
  Credit: "Credit",
  Refund: "Refund",
  MerchantSettlement: "Merchant Settlement",
  WalletUnload: "Wallet Unload",
  Remittance: "Remittance",
  ExternalApiDebit: "External API Debit",
  TransferFee: "Transfer Fee",
  WalletClose: "Wallet Close",
  AirtimeTopup: "Airtime Topup",
  BillPayment: "Bill Payment",
  Prefund: "Prefund",
  Issue: "Issue",
  AddFund: "Add Fund",
  ReturnFund: "Return Fund",
  Voucher: "Voucher",
  ClientRemittance: 'Client Remittance',
  MembershipPayment: 'Membership Payment',
  SetupFees: 'Setup Fees',
  AddSetupFees: 'Add Setup Fees',
  SendMoneyByUEN: 'Send Money By UEN',
  sendMoneyByQrCode: 'Send Money By QR',
  paymentCollection: 'Payment Collection',
  PaymentSettlement: 'Payment Settlement',
  AddMoneyCurrencyCloud: 'AddMoney Currency Cloud',
  SendMoneyCurrencyCloud: 'Send Money Currency Cloud',
  SendRefund: 'Send Refund',
  SendMoneyTorkeyTime: 'Send Money Torkey Time',
  DirectRemittancePaymentReceived: 'Direct Remittance Payment Received',
  BulkUploadCrossBorderSendMoney : 'Bulk Upload Cross Border Send Money',
  Recovery: 'Recovery',
  BulkUploadDomesticSendMoney : 'Bulk Upload Domestic Send Money'

};
export const TransactionTypesColor = {
  WalletCreate: "blue",
  SendMoney: "geekblue",
  AddMoney: "green",
  MerchantPay: "purple",
  Credit: "green",
  Refund: "red",
  MerchantSettlement: "orange",
  WalletUnload: "red",
  ExternalApiDebit: "red",
  TransferFee: "purple",
  WalletClose: "red",
  Remittance: "green",
  AirtimeTopup: "geekblue",
  BillPayment: "purple",
  Prefund: "red",
  AddFund: "purple",
  ReturnFund: "geekblue",
  Voucher: "purple",
  ClientRemittance: 'cyan',
  MembershipPayment: 'gold',
  SetupFees: 'yellow',
  AddSetupFees: 'yellow',
  Recovery: 'green',
  BulkUploadCrossBorderSendMoney : 'yellow',
  BulkUploadDomesticSendMoney : 'yellow'
};
export const RegulatoryTransactionType = {
  WalletCreate: 1,
  SendMoney: 2,
  AddMoney: 3,
  MerchantPay: 4, // 'Payment to Merchant'
  Credit: 5,
  Refund: 6,
  MerchantSettlement: 7,
  WalletUnload: 8,
  ExternalApiDebit: 9,
  TransferFee: 11,
  WalletClose: 12,
  Remittance: 13,
  AirtimeTopup: 14,
  BillPayment: 15,
  Prefund: 16,
  Issue: 17,
  AddFund: 21,
  ReturnFund: 22,
  Voucher: 18,
  ClientRemittance: 23
};

export const RegulatoryTransactionTypesText = {
  WalletCreate: "Wallet Create",
  SendMoney: "Wallet to Bank",
  AddMoney: "Add Money",
  MerchantPay: "Merchant Pay",
  Credit: "Credit",
  Refund: "Refund",
  MerchantSettlement: "Merchant Settlement",
  WalletUnload: "Wallet Unload",
  Remittance: "Remittance",
  ExternalApiDebit: "External API Debit",
  TransferFee: "Transfer Fee",
  WalletClose: "Wallet Close",
  AirtimeTopup: "Airtime Topup",
  BillPayment: "Bill Payment",
  Prefund: "Prefund",
  Issue: "Issue",
  AddFund: "Add Fund",
  ReturnFund: "Return Fund",
  Voucher: "Voucher",
  ClientRemittance: "Client Remittance",
  MonthlyRecurringFees: "Monthly Recurring Fees",
  AddMonthlyRecurring: "Add Monthly Recurring",
  VirtualTransfer: "Virtual Transfer"

};
export const RegulatoryTransactionTypesColor = {
  WalletCreate: "blue",
  SendMoney: "geekblue",
  AddMoney: "green",
  MerchantPay: "purple",
  Credit: "green",
  Refund: "red",
  MerchantSettlement: "orange",
  WalletUnload: "red",
  ExternalApiDebit: "red",
  TransferFee: "purple",
  WalletClose: "red",
  Remittance: "green",
  AirtimeTopup: "geekblue",
  BillPayment: "purple",
  Prefund: "red",
  AddFund: "purple",
  ReturnFund: "geekblue",
  Voucher: "purple",
  ClientRemittance: "magenta"
};
export const FormATransactionType = {
  AddMoney: 3,
  TransferFee: 11,
};
export const FormATransactionTypesText = {
  AddMoney: "Add Money",
  TransferFee: "Transfer Fee"
};
export const FormATransactionTypesColor = {
  AddMoney: "green",
  TransferFee: "purple",
};
export const FormBTransactionType = {
  MerchantPay: 4,
  Remittance: 13,
  AirtimeTopup: 14,
  BillPayment: 15,
  ClientRemittance: 23
};
export const FormBTransactionTypesText = {
  MerchantPay: "Merchant Pay",
  Remittance: "Remittance",
  AirtimeTopup: "Airtime Topup",
  BillPayment: "Bill Payment",
  ClientRemittance: "Client Remittance"

};
export const FormBTransactionTypesColor = {
  MerchantPay: "purple",
  Remittance: "green",
  AirtimeTopup: "geekblue",
  BillPayment: "purple",
  ClientRemittance: "magenta"

};
export const Form2ATransactionType = {
  SendMoney: 2,
  Remittance: 13,
  ClientRemittance: 23


};
export const Form2ATransactionTypesText = {
  SendMoney: "Wallet to Bank",
  Remittance: "Remittance",
  ClientRemittance: "Client Remittance"


};
export const Form2ATransactionTypesColor = {
  SendMoney: "geekblue",
  Remittance: "green",
  ClientRemittance: "magenta"

};
export const ReportTerminal = {
  TopupReport: 1,
  WalletTransferReport: 2,
  UnloadReport: 3,
  UserTransactionsNew: 4,
  WalletTransaction: 5,
  SettlementTransactions: 6,
  MerchantTransactionReportNew: 7,
  PendingTransactions: 8
}
export const OrderStatus = {
  Created: 1,
  Accepted: 2,
  Pending: 3,
  Delivered: 4,
  Rejected: 5,
  Cancelled: 6,
  PaymentPending: 7,
  Failed: 8,
  Expired: 9,
  Hold: 10,
  PaymentReceived: 11,
  Processing: 12,
  AmlInProgress: 13,
  AmlInReview: 14,

};
export const TopupType = {
  Mobile_no: "Mobile No",
  Account_no: "account_no"
}
  ;

export const TopupOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
];
export const TopupOptionsNew = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "transactionMonitoringNo", label: "TM No" }
];
export const usersFilter = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "displayName", label: "Display Name" },
  { value: "account_no", label: "Account No" },
];
export const BusinessTypeText = {
  true: "Remittance Merchant",
  false: "QR Merchant",
};
export const BusinessTypeColors = {
  true: 'green',
  false: 'red'
}
export const BusinessTypes = [
  { value: true, label: 'Remittance Merchant' },
  { value: false, label: 'QR Merchant' }
]
export const AppUserDeviceSignatureReportOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "displayName", label: "Display Name" },
  { value: "signature", label: "Signature" },
  { value: "documentNumber", label: "Document Number" },
  { value: "ipAddress", label: "IP Address" },
];
export const DeviceSignatureReportOptions = [
  { value: "emailId", label: "Email ID" },
  { value: "displayName", label: "Display Name" },
  { value: "signature", label: "Signature" },
  { value: "documentNumber", label: "Document Number" },
  { value: "ipAddress", label: "IP Address" },
];
export const DateTypes = [
  { label: "User Created On", value: "userDate" },
  { label: "Device Created On", value: "deviceDate" },
  { label: "Last Login", value: "lastLoginDate" }
];
export const TransactionStatusInfo = [
  { value: 1, label: "Order Created" },
  { value: 2, label: "Order Accepted" },
  { value: 3, label: "Order Pending" },
  { value: 4, label: "Order Delivered" },
  { value: 5, label: "Order Rejected" },
  { value: 6, label: "Order Cancelled" },
  { value: 7, label: "Payment Pending" },
  { value: 8, label: "Order Failed" },
  { value: 9, label: "Order Expired" },
  { value: 10, label: "Order Hold" },
  { value: 11, label: "Payment Received" },
  { value: 12, label: 'Order Processing' },
  { value: 13, label: 'AML In Progress' },
  { value: 14, label: 'AML In Review' },

];
export const TopupOptionsWallet = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "document_no", label: "Document No" },
  { value: "transaction_id", label: "Transaction No" },
  { value: "display_name", label: "Display Name" },
];
export const TransactionOptions = [
  { value: "transactionId", label: "TN No" },
  { value: "transactionMonitoringNumber", label: "TM No" }
]
export const formAOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "display_name", label: "Display Name" },

];
export const walletTransactionOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "display_name", label: "Display Name" },

];
export const SettlementTypes = [
  { value: true, label: 'Merchant Settlement' },
  { value: false, label: 'Location Settlement' }
]
export const OrderStatusText = {
  Created: "Order Created",
  Accepted: "Order Accepted",
  Pending: "Order Pending",
  Delivered: "Order Delivered",
  Rejected: "Order Rejected",
  Cancelled: "Order Cancelled",
  PaymentPending: "Payment Pending",
  Failed: "Order Failed",
  Expired: "Order Expired",
  Hold: "Order Hold",
  PaymentReceived: "Payment Received",
  Processing: 'Order Processing',
  AmlInProgress: 'AML In Progress',
  AmlInReview: 'AML In Review',

};

export const VirtualTransactionStatusOptions = [
  { value: '6', label: 'Cancel' },
  { value: '7', label: 'Payment Pending' },
  { value: '8', label: 'Failed' },
  { value: '11', label: 'Received' },
  { value: '12', label: 'Processing' },
  { value: '15', label: 'Paid' },
  { value: '16', label: 'Approval Pending' },
  { value: '17', label: 'Approval Rejected' },
  { value: '3', label: 'Pending' },
  { value: '18', label: 'Compliance' },
  { value: '5', label: 'Rejected' },
  { value: '2', label: 'Accepted' },
  { value: '9', label: 'Expired' },
  { value: '19', label: 'Refunded' },
  { value: '20', label: 'Payment Credited' },
  { value: '21', label: 'Payment Reversed' },
  { value: '23', label: 'Partial Refunded' },
  { value: '22', label: 'Disputed' }, 

];

export const VirtualTransactionText = {
  PaymentPending: 'Payment Pending',
  Failed: 'Failed',
  Received: 'Received',
  Processing: 'Processing',
  Paid: 'Paid',
  ApprovalPending: 'Approval Pending',
  ApprovalRejected: 'Approval Rejected',
  Pending: 'Pending',
  Compliance: 'Compliance',
  Rejected: 'Rejected',
  Accepted: 'Accepted',
  Expired: 'Expired',
  Refunded: 'Refunded',
  PaymentCredited: 'Payment Credited',
  Cancel: 'Cancel',
  PartialRefunded: 'Partial Refunded',
  Disputed: 'Disputed',  
}

export const VirtualTransactionStatusValues = {
  Created: 1,
  Accepted: 2,
  Pending: 3,
  Delivered: 4,
  Rejected: 5,
  Cancel: 6,
  PaymentPending: 7,
  Failed: 8,
  Expired: 9,
  Hold: 10,
  Received: 11,
  Processing: 12,
  AmlInProgress: 13,
  AmlInReview: 14,
  Paid: 15,
  ApprovalPending: 16,
  ApprovalRejected: 17,
  Compliance: 18,
  Refunded: 19,
  PaymentCredited: 20,
  PaymentReversed: 21,
  PartialRefunded: 23,
  Disputed: 22,     
};

export const VirtualTransactionStatusColors = {
  Created: 'blue',
  Accepted: 'green',
  Pending: 'orange',
  Delivered: 'green',
  Rejected: 'red',
  Cancel: 'red',
  PaymentPending: 'volcano',
  Failed: 'red',
  Expired: 'red',
  Hold: 'orange',
  Received: 'green',
  Processing: 'cyan',
  AmlInProgress: 'blue',
  AmlInReview: 'orange',
  Paid: 'green',
  ApprovalPending: 'orange',
  ApprovalRejected: 'red',
  Compliance: 'blue',
  Refunded: 'green',
  PaymentCredited: 'green',
  PaymentReversed: 'yellow',
  Disputed: 'orange', 
  PartialRefunded: 'orange',
};

export const VirtualTransactionStatusText = {
  Created: 'Created',
  Accepted: 'Accepted',
  Pending: 'Pending',
  Delivered: 'Delivered',
  Rejected: 'Rejected',
  Cancel: 'Cancel',
  PaymentPending: 'Payment Pending',
  Failed: 'Failed',
  Expired: 'Expired',
  Hold: 'Hold',
  PaymentReceived: 'Received',
  Processing: 'Processing',
  AmlInProgress: 'AML In Progress',
  AmlInReview: 'AML In Review',
  Paid: 'Paid',
  ApprovalPending: 'Approval Pending',
  ApprovalRejected: 'Approval Rejected',
  Compliance: 'Compliance',
  Refunded: 'Refunded',
  PaymentCredited: 'Payment Credited',
  PaymentReversed: 'Payment Reversed',
  Disputed: 'Disputed',
};

/*For the transaction list in dashboard*/
export const VirtualTransactionStatusColors2 = {
  PaymentPending: 'orange',
  Pending: 'orange',
  ApprovalPending: 'orange',
  Failed: 'red',
  ApprovalRejected: 'red',
  Rejected: 'red',
  PaymentReceived: 'blue',
  Accepted: 'blue',
  Processing: 'orange',
  Paid: 'red',
  Compliance: 'purple'
};


export const OrderStatusColor = {
  Created: "blue",
  Accepted: "purple",
  Pending: "volcano",
  Delivered: "green",
  Rejected: "red",
  Cancelled: "red",
  PaymentPending: "orange",
  Failed: "red",
  Expired: "red",
  Hold: "orange",
  PaymentReceived: "green",
  Processing: 'cyan',
  AmlInProgress: 'orange',
  AmlInReview: 'purple',

};
export const OrderStatusOptions = [
  { value: 1, label: "Order Created" },
  { value: 2, label: "Order Accepted" },
  { value: 3, label: "Order Pending" },
  { value: 4, label: "Order Delivered" },
  { value: 5, label: "Order Rejected" },
  { value: 6, label: "Order Cancelled" },
  { value: 7, label: "Payment Pending" },
  { value: 8, label: "Order Failed" },
  { value: 9, label: "Order Expired" },
  { value: 10, label: "Order Hold" },
  { value: 11, label: "Payment Received" },
  { value: 12, label: 'Order Processing' },
  { value: 13, label: 'AML In Progress' },
  { value: 14, label: 'AML In Review' },

];
type ArrayType = Array<{ value: string; label: string }>;
export const CountryList = [
  {
    code: "SGP",
    name: "Singapore",
    dialCode: "+65",
    currencySymbol: "$",
    id: 1,
  },
  { code: "IND", name: "India", dialCode: "+91", currencySymbol: "₹", id: 2 },
  {
    code: "PHL",
    name: "Philippines",
    dialCode: "+63",
    currencySymbol: "₱",
    id: 3,
  },
];

export const CurrencySymbols = {
  Singapore: "$",
  India: "₹",
  Philippines: "₱",
};
export const MerchantCategoryList = [
  "Lifestyle",
  "Medical",
  "Food",
  "Others",
  "Travel",
  "Household",
  "Entertainment",
];

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const weekDaysOptions = [
  { label: 'Sunday', value: 7 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];
export const TransactionTypeOptions = [
  { value: 1, label: "Wallet Create" },
  { value: 2, label: "Send Money" },
  { value: 3, label: "Add Money" },
  { value: 4, label: "Merchant Pay" },
  { value: 6, label: "Refund" },
  { value: 8, label: "Wallet Unload" },
  { value: 11, label: "Transfer Fee" },
  { value: 12, label: "Wallet Close" },
  { value: 13, label: "Remittance" },
  { value: 14, label: "AirtimeTopup" },
  { value: 15, label: "BillPayment" },
  { value: 18, label: "Voucher" },
  { value: 23, label: "Client Remittance" },
  { value: 20, label: "Membership Payment" },
  { value: 33, label: 'Setup Fees' },
  { value: 34, label: 'Add Setup Fees' },
  { value: 35, label: 'Send Money By UEN' },
  { value: 36, label: 'Send Money By QR' },
  { value: 37, label: 'Payment Collection' },
  { value: 38, label: 'Payment Settlement' },

];
export const FormATransactionTypeOptions = [
  { value: 3, label: "Add Money" },
  { value: 11, label: "Transfer Fee" },
]; export const FormBTransactionTypeOptions = [
  { value: 4, label: "Merchant Pay" },
  { value: 13, label: "Remittance" },
  { value: 14, label: "AirtimeTopup" },
  { value: 15, label: "BillPayment" },
  { value: 23, label: "ClientRemittance" },

];
export const Form4TransactionTypeOptions = [
  { value: 4, label: "Merchant Pay" },
  { value: 14, label: "AirtimeTopup" },
  { value: 15, label: "BillPayment" },
];
export const Form2ATransactionTypeOptions = [
  { value: 2, label: "Wallet to Bank" },
  { value: 13, label: "Remittance" },
  { value: 11, label: "Transfer Fee" },
  { value: 23, label: "Client Remittance" }
];
export const PrefundTypes = [
  { value: true, label: "Available" },
  { value: false, label: "Un Available" },
];
export const displayName = {
  customerScoreCatergory: 'customer_risk_score_category'
}
export const ReportTerminals = {
  topupReport: "Topup Report",
  unloadReport: "Unload Report",
  walletTransactionReport: "Wallet Transfer Report",
  merchantTransactionReport: "Merchant Transaction Report",
  merchantTransactionReportNew: "Merchant Transaction Report New",
  agentReport: "Agents Report",
  branches: "Branches",
  roles: "Roles",
  agentUsers: "Agent Users",
  adminUsersReport: "Admin Users Report",
  adminUsersReports: "Admin Users Reports",
  KycAdminUserReports: "KYC Users Reports",
  agentUsersReport: "Agent Users Report",
  merchantProductReport: "Merchant Product Report",
  kycUsersReport: "KYC Users Report",
  merchantUsersReport: "Merchant Users Report",
  remittanceUsersReport: "Remittance Users Report",
  adminUsersReport2: "Admin Users Report2",
  allUsersReport: "All Users Report",
  allUsersList: "All Users List",
  appUsers: "App Users",
  appUsersList: "App Users List",
  oTPVerifiedUsers: "OTP Verified Users",
  oTPVerifiedUsersList: "OTP Verified Users List",
  userAllReport: "All User Report",
  appUsersReport: "App Users Report",
  merchantsReport: "Merchants Report",
  merchantsReport2: "Onboarding Merchants Report",
  locations: "Locations",
  terminals: "Terminals",
  merchantUsers: "Merchant Users",
  refundReport: "Refund Report",
  merchantStatementReport: "Merchant Statement Report",
  preapprovedUsersReport: "Preapproved Users",
  merchantSettlement: "Merchant Settlement",
  merchantSettlementReport: "Merchant Settlement Report",
  merchantSettlements: "Merchant Settlements",
  merchantSettlementDetails: "Merchant Settlement Details",
  merchantSettlementPending: "Merchant Settlement Pending",
  merchantSettlementPendingNew: "Merchant Settlement Pending New",
  agentStatement: "Agent Statement",
  settledTransactions: "Settlement Transactions",
  inAppPurchase: "In App Purchase",
  remittance: "Remittance Transactions",
  kycReport: "Kyc Report",
  userTransactions: "User Transactions",
  userTransactionsLatest: "User Transactions Latest",
  formA: "Form 1A.1(a) Report",
  formB: "Form 1A.1(b) Report",
  form4A: "Form 4A.1a Report",
  form5E: "Form 5 Report",
  form52: "Form 5.2 Report",
  form2A: "Form 2A.1 Report",
  form3A: "Form 1A.3(a) Report",
  form3C: "Form 1A.3(c) Report",
  form3D: "Form 1A.3(d) Report",
  form4: "Form 1A.4 Report",
  form1B: "Form 1B.(1) Report",
  form1B2: "Form 1B.(2) Report",
  form1B3A: "Form 1B.3(a) Report",
  form1B3B: "Form 1B.3(b) Report",
  form2B: "Form 2B.(1) Report",
  form3: "Form 2B.(3) Report",
  form1BSA: "Form 4B.1(b) Report",
  form3SA: "Form 4B.(3) Report",
  form2SA: "Form 4B.2(a) Report",
  form2B4: "Form 2B.(4) Report",
  userTransactionsNew: "User Transactions New",
  userTransactionSummary: "User Transaction Summary",
  transactionMonitoring: "Transaction Monitoring",
  walletBalance: "Wallet Balance",
  payoutAgents: "Payout Agents",
  countries: "Countries",
  faq: "FAQs",
  remittanceUsers: "Remittance Users",
  topupParking: "Topup Parking",
  topupParkingReport: "Topup Parking Report",
  prefundTransactions: "Prefund Transactions",
  agentLedgers: "Agent Ledger",
  agentTransactionsReport: "Agent Transactions Report",
  merchantSettlementPendingTransactions: "Pending Transactions",
  merchantDailySummary: "Merchant Transactions Daily Summary",
  kycActivity: "KYC Activity",
  currencies: "Currencies",
  promocodes: "Promocodes",
  remittanceProviderPayment: "Remittance Provider Payment",
  activityReport: "Users Activity",
  usageSmsEmailReport: "Sms/Email Report",
  usageSmsReport: "SMS Report",
  usageEmailReport: "Email Report",
  usageKycAmlReport: "Kyc/Aml Report",
  usageTopupChannelReport: "Topup Channel Report",
  kycCheckReport: "kYC Check Report",
  amlCheckReport: "AML Check Report",
  pointListReport: "Point Report",
  usersPointReport: "Users Point Report",
  redeemPoint: "Redeem Point",
  userTierReport: "User Tier Report",
  expenseLedgerReport: "Expense Ledger Report",
  OTPVerifiedUsers: "OTP Verified Users Report",
  wallet: "Wallet",
  walletToBank: "Wallet To Bank",
  accountIssuanceService: 'Account Issuance Service',
  responseMessage: 'App Response Messages',
  notificationTemplate: 'Notification Template',
  languageReport: 'Languages',
  changeMobile: 'Change Mobile No Report',
  transactionReport: 'Transaction Report',
  moneyExchangeRate: 'Money Exchange Rate ',
  walletTransactions: 'Wallet Transactions',
  walletTransactionsNew: 'Wallet Transaction',
  appUserSignatureReport: 'App User',
  adminUserSignatureReport: 'Admin User',
  walletTransactionSummary: "Wallet Transaction Summary",
  changeMobileHistory: "Change Mobile History",
  membershipReport: "Membership Users Report",
  providerUserReport: "Provider Users Report",
  TransactionReport: "Transaction Reports",
  remittanceProviderCountries: 'Remittance Provider Countries',
  virtualAccountUser: 'Virtual Account Users',
  complianceQueueList: 'Compliance Queue List',
  transactionListReport: "Transaction List Reports",
  businessTransactionListReport: "Business Transaction List Reports",

};

export const WebPortalUserReportFileNames = {
  adminUsersReport: "Admin Users Report",
  agentUsersReport: "Agent Users Report",
  kycUsersReport: "KYC Users Report",
  merchantUsersReport: "Merchant Users Report",
  remittanceUsersReport: "Remittance Users Report"
};

//****************************************************************SERVER CONFIGURATION STARTS************************************************************* */

// DEV*********************************
export const AppCode = [
  { value: "", label: "ALL" },
  { value: "01", label: "DEV" },
  { value: "24", label: "JDee" },
  { value: "21", label: "Agrani" }
];

export const AppCodeForCreate = [
  { value: "*", label: "ALL" },
  { value: "01", label: "DEV" },
  { value: "24", label: "JDee" },
  { value: "21", label: "Agrani" }
];
// DEV*********************************

// SGUAT*********************************
export const UATSGAppCode = [
  { value: "", label: "ALL" },
  { value: "04", label: "SandBox UAT" },
  { value: "25", label: "MetroRemit" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "35", label: "PERKD" },
  { value: "23", label: "Zhongguo" },
  { value: "36", label: "LMPay" },
  { value: "29", label: "ADB Pay" },
  { value: "20", label: "HalongPay" },
  { value: "21", label: "Agrani" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  //{value:"15",label:"FortuneTech"}
];
export const UATAppCodeForCreateSG = [
  { value: "*", label: "ALL" },
  { value: "04", label: "SandBox UAT" },
  { value: "25", label: "MetroRemit" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "35", label: "PERKD" },
  { value: "23", label: "Zhongguo" },
  { value: "36", label: "LMPay" },
  { value: "29", label: "ADB Pay" },
  { value: "20", label: "HalongPay" },
  { value: "21", label: "Agrani" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  //{value:"15",label:"FortuneTech"}
];
// SGUAT*********************************

// PHLUAT*********************************
export const UATPHLAppCode = [
  { value: "", label: "ALL" },
  { value: "29", label: "ADB Pay" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "25", label: "MetroRemit" },
  { value: "24", label: "JDee" },
  { value: "21", label: "Agrani" },
  { value: "36", label: "LMPay" },
  { value: "37", label: "FlexMPay" },
  { value: "20", label: "HalongPay" },
  { value: "10", label: "FlexBank" },
  { value: "11", label: "Connect" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  { value: "15", label: "FortuneTech" },
];


export const UATAppCodeForCreatePHP = [
  { value: "*", label: "ALL" },
  { value: "29", label: "ADB Pay" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "25", label: "MetroRemit" },
  { value: "24", label: "JDee" },
  { value: "21", label: "Agrani" },
  { value: "36", label: "LMPay" },
  { value: "37", label: "FlexMPay" },
  { value: "20", label: "HalongPay" },
  { value: "10", label: "FlexBank" },
  { value: "11", label: "Connect" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  { value: "15", label: "FortuneTech" },
  { value: "40", label: "FlexM" },
];
// PHLUAT*********************************

// JUFU UAT*********************************
export const UATAppcodeForJufu = [
  { value: "", label: "ALL" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
];
export const UATAppcodeForJufuCreate = [
  { value: "*", label: "ALL" },
  { value: "31", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
];
// JUFU UAT*********************************

// US UAT*********************************
export const UATAppCode = [
  { value: "", label: "ALL" },
  { value: "20", label: "HalongPay" }
];


export const UATAppCodeForCreateUS = [
  { value: "*", label: "ALL" },
  { value: "20", label: "HalongPay" }
];


// US UAT*********************************

// CAD UAT **************************************
export const UATAppCodeCAD = [
  { value: "", label: "ALL" },
  { value: "11", label: "Connect" },
];

export const UATAppCodeForCreateCAD = [
  { value: "*", label: "ALL" },
  { value: "11", label: "Connect" },
];
// CAD UAT **************************************

// LIVESG *************************************
export const LiveAppCodeForSG = [
  { value: "", label: "ALL" },
  { value: "26", label: "Beam&Go" },
  { value: "23", label: "Zhongguo" },
  { value: "32", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "25", label: "MetroRemit" },
  { value: "24", label: "JDee" },
  { value: "38", label: "Steadfast" },
  { value: "36", label: "LMPay" },
  { value: "39", label: "PayGo" },
  { value: "34", label: "Crown Exchange" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  //{ value: "15", label: "FortuneTech" }
];

export const LiveAppCodeSGForCreate = [
  { value: "*", label: "ALL" },
  { value: "26", label: "Beam&Go" },
  { value: "23", label: "Zhongguo" },
  { value: "32", label: "JuFu Remit" },
  { value: "33", label: "ATT Remit" },
  { value: "25", label: "MetroRemit" },
  { value: "24", label: "JDee" },
  { value: "38", label: "Steadfast" },
  { value: "36", label: "LMPay" },
  { value: "39", label: "PayGo" },
  { value: "34", label: "Crown Exchange" },
  { value: "12", label: "6G Mustafa Pay" },
  { value: "13", label: "YourPay" },
  //{ value: "15", label: "FortuneTech" }
];

// LIVESG *************************************

// ADB-PHL LIVE **************************************
export const LiveAppCodeForPHP = [
  { value: "", label: "ALL" },
  { value: "30", label: "ADB Pay" },
];

export const LiveAppCodePHPForCreate = [
  { value: "*", label: "ALL" },
  { value: "30", label: "ADB Pay" },
];
// ADB-PHL LIVE **************************************


// CAD LIVE **************************************
export const LiveAppCodeForCAD = [
  { value: "", label: "ALL" },
  { value: "11", label: "Connect" },
];

export const LiveAppCodeCADForCreate = [
  { value: "*", label: "ALL" },
  { value: "11", label: "Connect" },
];
// CAD LIVE **************************************
export const AppCodeForBizBoard = [
  { value: "*", label: "ALL" },
  { value: "40", label: "FlexM" },
  { value: "41", label: "Torkey Times" },

]

export const currencyForAppCode = [
  { currency: "SGD", appCode: "*", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "01", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "02", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "04", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "10", country: "Singapore", symbol: "$" },
  { currency: "CAD", appCode: "11", country: "Canada", symbol: "$" },
  { currency: "SGD", appCode: "12", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "13", country: "Singapore", symbol: "$" },
  { currency: "USD", appCode: "20", country: "United States of America", symbol: "$" },
  { currency: "SGD", appCode: "21", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "23", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "24", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "25", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "26", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "28", country: "Singapore", symbol: "$" },
  { currency: "PHP", appCode: "29", country: "Philippines", symbol: "₱" },
  { currency: "PHP", appCode: "30", country: "Singapore", symbol: "₱" },
  { currency: "SGD", appCode: "31", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "32", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "33", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "34", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "35", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "36", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "37", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "38", country: "Singapore", symbol: "$" },
  { currency: "SGD", appCode: "39", country: "Singapore", symbol: "$" },
  { currency: "PHP", appCode: "15", country: "Philippines", symbol: "₱" },
];
export const currencyForALLAppcode = [
  { instance: "DEV", symbol: '$' },
  { instance: "uatSG", symbol: '$' },
  { instance: "uatPHP", symbol: '₱' },
  { instance: "LIVESG", symbol: '$' },
  { instance: "livePHP", symbol: '₱' },
  { instance: "uatCAD", symbol: '$' },
  { instance: "LIVECAD", symbol: '$' }
];
export const InstanceName = {
  dev: "DEV",
  uatSG: "uatSG",
  uatPHP: "uatPHP",
  liveSG: "LIVESG",
  livePHP: "livePHP",
  JufuUAT: "JufuUAT",
  uatUS: "uatUS",
  uatCAD: 'uatCAD',
  liveCAD: 'LIVECAD',
  flexBiz: 'flexBiz'
};

export const appCodeValue = {
  all: "*",
  FlexM: "40",
  TorkeyTimes: "41"
};
export const ATTEmail = {
  email: 'admin@attremit'
}

export const appCodeCreate = [
  { label: "all", value: "*" },
  { label: "dev", value: "01" },
  { label: "test", value: "02" },
  { label: "sandboxUAT", value: "04" },
  { label: "MetroRemit", value: "05" },
  { label: "Flexbank", value: "10" },
  { label: "Connect", value: "11" },
  { label: "SG_6GPay", value: "12" },
  { label: "YourPay", value: "13" },
  { label: "HalongPay", value: "20" },
  { label: "Agrani", value: "21" },
  { label: "Zhongguo", value: "23" },
  { label: "JDee", value: "24" },
  { label: "MetroRemitLive", value: "25" },
  { label: "beamNGoLive", value: "26" },
  { label: "adbLive", value: "27" },
  { label: "kingsRemitLive", value: "28" },
  { label: "PhlUAT", value: "29" },
  { label: "PhlLive", value: "30" },
  { label: "JufuUat", value: "31" },
  { label: "JufuLive", value: "32" },
  { label: "ATT ", value: "33" },
  { label: "CrownExchange", value: "34" },
  { label: "PERKD", value: "35" },
  { label: "LMPay", value: "36" },
  { label: "FlexMPay", value: "37" },
  { label: "Steadfast", value: "38" },
  { label: "PayGo", value: "39" },
  { label: "FortuneTech", value: "15" }
];
export const AppCodes = {
  all: "*",
  dev: "01",
  test: "02",
  sandboxUAT: "04",
  adbUATNew: "29",
  BeamAndGo: "26",
  ADBPAY: "30",
  KingsRemit: "28",
  Zhongguo: "23",
  MetroRemit: "25",
  JufuUAT: "31",
  Jufu: "32",
  ATT: "33",
  PERKD: "35",
  JDee: "24",
  Agrani: "21",
  LMPay: "36",
  FlexMPay: "37",
  Steadfast: "38",
  PayGo: "39",
  CrownExchange: "34",
  HalongPay: "20",
  FlexBank: "10",
  Connect: "11",
  '6GMustafaPay': "12",
  YourPay: "13",
  FortuneTech: "15",
  FlexM: "40",
  TorkeyTimes: "41"
};
export const Address = {
  "24": "304 Orchard Rd, #02-19, Singapore 238863",
  "29": "Asian Development Bank,\n 6 ADB Avenue,\n Mandaluyong City",
  "30": "Asian Development Bank,\n 6 ADB Avenue,\n Mandaluyong City",
  "32": "345 Geylang Road, Pavilion Square, #01-12, Singapore 389366",
  "31": "345 Geylang Road, Pavilion Square, #01-12, Singapore 389366",
  "": "831 Lipsum dolar Fountain Valley, CA 92708 Singapore",
  "33": "Aljunied MRT Station, #01-10 Lor 25 Geylang, 388310",
  "25": "86/87/88 Lucky Plaza, 304 Orchard Road, Singapore 238863",
  "20": "304 Orchard Rd, #02-19, US 238863"
}
// currently using
export const AppCodeName = {
  all: "ALL",
  dev: "DEV",
  test: "TEST",
  sandboxUAT: "SandBox UAT",
  adbUATNew: "ADB Pay",
  BeamAndGo: "Beam&Go",
  ADBPAY: "ADB Pay",
  Zhongguo: "Zhongguo",
  MetroRemit: "MetroRemit",
  JufuUAT: "JuFu Remit",
  Jufu: "JuFu Remit",
  ATT: "ATT Remit",
  PERKD: "PERKD",
  JDee: "JDee",
  Agrani: "Agrani",
  LMPay: "LMPay",
  FlexMPay: "FlexMPay",
  Steadfast: "Steadfast",
  PayGo: "PayGo",
  CrownExchange: "Crown Exchange",
  HalongPay: "HalongPay",
  FlexBank: "FlexBank",
  Connect: "Connect",
  '6GMustafaPay': "6G Mustafa Pay",
  YourPay: "YourPay",
  FortuneTech: "FortuneTech",
  FlexM: 'FlexM',
  TorkeyTimes: 'Torkey Times'
};
// currently using
export const appCodeColor = {
  sandboxUAT: "volcano",
  dev: "purple",
  test: "magenta",
  all: "green",
  BeamAndGo: "volcano",
  ADBPAY: "geekblue",
  KingsRemit: "purple",
  Zhongguo: "magenta",
  adbUATNew: "magenta",
  Jufu: "magenta",
  JufuUAT: "magenta",
  ATT: "orange",
  PERKD: "magenta",
  JDee: "volcano",
  Agrani: "gold",
  LMPay: "cyan",
  FlexMPay: "lime",
  Steadfast: "cyan",
  PayGo: "lime",
  MetroRemit: "orange",
  CrownExchange: "gold",
  HalongPay: "#B8DCF9",
  FlexBank: "#2684FF",
  Connect: "#41bdd3",
  '6GMustafaPay': "gold",
  YourPay: "#DFB3F0",
  FortuneTech: "purple",
  FlexM: "blue",
  TorkeyTimes: 'purple'
};

//****************************************************************SERVER CONFIGURATION ENDS************************************************************* */

export const configParams = {
  appName: "Admin Board",
  address: "#304 Orchard Road",
  country: "Singapore",
};

export const UserStatus = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  // Locked: 3,
  Flagged: 4,
  UnFlagged: 5,
  ClosureRequested: 6,
  Blocked: 7,
  NotCreated: -1,
  InReview: 4
};
export const Status = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  Locked: 3,
  Flagged: 4,
  UnFlagged: 5,
  ClosureRequested: 6,
  Blocked: 7,
  NotCreated: -1
};
export const BannerStatus = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  Locked: 3,
  Flagged: 4,
  Expired: 5
}
export const BannerStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  Locked: "Locked",
  Flagged: "Flagged",
  Expired: "Expired"
}
export const StatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  Locked: "Locked",
  Flagged: "In Review",
  UnFlagged: "UnFlagged",
  ClosureRequested: "Closure Requested",
  Blocked: "Blocked",
  NotCreated: "NotCreated"
};
export const userStatusWalletOptions = [
  { value: 1, label: "Active" },
  { value: 7, label: "Blocked" },
  { value: 6, label: "Closure Requested" },
  { value: 0, label: "Deleted" },
  { value: 2, label: "In Active" },
  { value: 4, label: "In Review" },
  { value: 3, label: "Locked" },
  { value: 5, label: "Un Flagged" },
  { value: -1, label: "Not Created" }
];
export const UserStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  // Locked: "Locked",
  Flagged: "In Review",
  UnFlagged: "UnFlagged",
  ClosureRequested: "Closure Requested",
  Blocked: "Blocked",
  NotCreated: "NotCreated"
};
export const StatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  Locked: "red",
  Flagged: "cyan",
  UnFlagged: "blue",
  ClosureRequested: "red",
  Blocked: "red",
  NotCreated: "blue"
};
export const UserStatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  // Locked: "red",
  Flagged: "cyan",
  UnFlagged: "blue",
  ClosureRequested: "red",
  Blocked: "red",
  NotCreated: "blue"
};
export const accountHolderTypes = [
  { value: 'individual', label: "Individual" },
  { value: 'company', label: "Company" }
]
export const PepOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]
export const userStatusOptions = [
  { value: 1, label: "Active" },
  { value: 7, label: "Blocked" },
  { value: 6, label: "Closure Requested" },
  { value: 0, label: "Deleted" },
  { value: 2, label: "In Active" },
  { value: 4, label: "In Review" },
  // { value: 3, label: "Locked" },
  { value: 5, label: "Un Flagged" },
];
export const userStatusOptionsNew = [
  { value: 1, label: "Active" },
  { value: 7, label: "Blocked" },
  { value: 6, label: "Closure Requested" },
  //{ value: 0, label: "Deleted" },
  { value: 2, label: "In Active" },
  { value: 4, label: "In Review" },
  { value: 5, label: "Un Flagged" },
];
export const userStatusEditOptions = [
  { value: 1, label: "Active" },
  { value: 7, label: "Blocked" },
  { value: 4, label: "In Review" },
];
export const userStatusForOTPVerifiedUsers = [
  { value: 1, label: "Active" },
  { value: 4, label: "In Review" },
];
export const statusForGiftcard = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];
export const statusForAppSettings = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
];
export const statusForBranches = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];
export const statusForWebPortal = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 0, label: "Deleted" },
];
export const statusForProviders = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];

export const statusForProduct = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];

export const statusForApp = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
];
export const statusForRewardPoints = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];
export const statusForRewardPointsType = {
  Active: 1,
  InActive: 0,
};
export const statusForLocation = {
  Active: 1,
  InActive: 2,
};
export const statusLocationColor = {
  Active: 'green',
  InActive: 'red',
};
export const statusLocationText = {
  Active: 'Active',
  InActive: 'In Active',
};

export const SettlementFrequency = {
  on: true,
  off: false,
};
export const SettlementFrequencyStatusText = {
  on: "On",
  off: "Off",
};
export const SettlementFrequencyStatus = {
  on: 1,
  off: 0,
};
type PaymentTypes = Array<{ value: string; label: string }>;
export const PaymentTypeOptions: PaymentTypes = [
  { value: "Cash", label: "Cash" },
  { value: "BankTransfer", label: "Bank Transfer" },
  { value: "CDMDeposit", label: "CDM Deposit" },
  { value: "PayNow", label: "PayNow" },
  { value: "7Eleven", label: "7Eleven" },
  { value: "Card", label: "Card" },
  { value: "BOG", label: "BOG" },
  { value: "BOGX", label: "BOGX" },
];
export const WalletTopupPaymentTypeOptions: PaymentTypes = [
  { value: "Cash", label: "Cash" },
  { value: "BankTransfer", label: "Bank Transfer" },
  { value: "CDMDeposit", label: "CDM Deposit" },
  { value: "PayNow", label: "PayNow" },
  { value: "7Eleven", label: "7Eleven" },
  { value: "Card", label: "Card" }
];
export const FooterStaticValue = {
  encryptedAmount: "***"
}
export const PaymentModes = {
  BankTransfer: "BankTransfer",
  cash: "Cash",
  wallet: "Wallet",
  CDMDeposit: "CDMDeposit",
  PayNow: "PayNow",
  bulkLoad: "BulkLoad",
  bulkUnload: "BulkUnload",
  sevenEleven: "7Eleven",
  AgentTopup: "Agent Topup",
  cheque: "Cheque",
  store: "Store",
  card: "Card",
  Voucher: "Voucher",
  Bank: "Bank", //added for wallet to bank fitering,
  BillPaymentTopup: "BillPaymentTopup",
  ETransfer: "ETransfer"
};
export const PaymentModesText = {
  BankTransfer: "Bank Transfer",
  cash: "Cash",
  wallet: "Wallet",
  CDMDeposit: "CDM Deposit",
  PayNow: "PayNow",
  bulkLoad: "Bulk Load",
  bulkUnload: "Bulk Unload",
  sevenEleven: "7Eleven",
  AgentTopup: "Agent Topup",
  cheque: "Cheque",
  store: "Store",
  Voucher: "Voucher",
  BillPaymentTopup: "BillPayment Topup",
  ETransfer: "ETransfer"
};
export const PaymentModesColor = {
  BankTransfer: "geekblue",
  cash: "blue",
  wallet: "green",
  CDMDeposit: "volcano",
  PayNow: "purple",
  bulkLoad: "magenta",
  bulkUnload: "red",
  sevenEleven: "green",
  AgentTopup: "green",
  cheque: "green",
  store: "green",
  Voucher: "magenta",
  BillPaymentTopup: "#6E96A8",
  ETransfer: "#590559"
};
export const AppTerminals = {
  backOffice: "Backoffice",
  inApp: "InApp",
};

export const closeAccountPaymentModes = [
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  { value: "BankTransfer", label: "Bank Transfer" },
];
export const PaymentTypeFilterOptionsForAllTransactions = [
  { value: "Cash", label: "Cash" },
  { value: "BankTransfer", label: "Bank Transfer" },
  { value: "CDMDeposit", label: "CDM Deposit" },
  { value: "PayNow", label: "PayNow" },
  { value: "7Eleven", label: "7Eleven" },
  { value: "Wallet", label: "Wallet" },
  { value: "cheque", label: "Cheque" },
  { value: "BulkLoad", label: "Bulk Load" },
  { value: "BulkUnload", label: "Bulk Unload" },
  { value: "Card", label: "Card" },
  { value: "BOG", label: "BOG" },
  { value: "BOGX", label: "BOGX" },
  { value: "Wallet Transfer", label: "Wallet Transfer" },
  { value: "ETransfer", label: "ETransfer" },
  { value: "BillPaymentTopup", label: "BillPayment Topup" },

];
export const remittancePaymentModes = [
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  { value: "BankTransfer", label: "Bank Transfer" },
  { value: "Wallet", label: "Wallet" },
  { value: "PayNow", label: "PayNow" },
  { value: "Store", label: "Store" }
];
export const agentTransactionPaymentModes = [
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  { value: "BankTransfer", label: "Bank Transfer" },
  { value: "WALLET", label: "Wallet" },
  { value: "Gift card", label: "Gift card" },
  { value: "Voucher", label: "Voucher" }

];
export const WalletUnloadPaymentModes = [
  { value: "Cash", label: "Cash" },
  { value: "BankTransfer", label: "Bank Transfer" },
];
export const WalletUnloadReasons = [
  { value: "Going to another Country", label: "Going to another Country" },
  {
    value: "I want to uninstall the application",
    label: "I want to uninstall the application",
  },
  { value: "I lost my Phone", label: "I lost my Phone" },
  { value: "Close account", label: "Close account" },
  { value: "Others", label: "Others" },
];
export const SettlementStatus = {
  unSettled: false,
  settled: true,
};
export const BusinessModel = [
  "Retail Store",
  "E-commerce (website)",
  "Trade/Office",
  "Others",
];
export const MonthDates = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
export const SettlementDocumentStatus = {
  open: 0,
  paid: 1,
  hold: 2,
  failed: 3,
  processing: 4,
};
export const textForSettlementDocumentStatus = {
  open: "Open",
  paid: "Paid",
  hold: "Hold",
  failed: "Failed",
  processing: "Processing",
};
export const colorForSettlementDocumentStatus = {
  open: "green",
  paid: "red",
  hold: "orange",
  failed: "red",
  processing: "purple",
};
export const settlementDocumentStatusOptions = [
  { value: 0, label: "Open" },
  { value: 1, label: "Paid" },
];
export const settlementDocumentStatusFilterOptions = [
  { value: 0, label: "Open" },
  { value: 1, label: "Paid" },
  { value: 2, label: "Hold" },
  { value: 3, label: "Failed" },
  { value: 4, label: "Processing" },
];
export const merchantUserTypes = [
  { value: "location-user", label: "Location User" },
  { value: "merchant", label: "Merchant User" },
  { value: "location-manager", label: "Location Manager" },
];

export const settlementTypesOptions = [
  { value: "auto", label: "Auto" },
  { value: "demand", label: "Demand" },
];
export const SettlementType = {
  auto: "auto",
  demand: "demand",
};
export const LocationsettlementTypesOptions = [{ value: 0, label: "Banks" }];
export const TransactionAccountTypes = {
  refund: "REFUND",
  settlement: "SETTLEMENT",
  qrPayment: "PAYMENT",
  externalPayment: "EXTERNAL PAYMENT",
  wallet: "WALLET",
  "MONTHLY-TRANSFER-FEE": "MONTHLY-TRANSFER-FEE"

};
export const TransactionAccountTypeOptions = [
  { value: "REFUND", label: "Refund" },
  { value: "SETTLEMENT", label: "Settlement" },
  { value: "PAYMENT", label: "Payment" },
];
export const TransactionAccountTypeOptionsNew = [
  { value: "REFUND", label: "Refund" },
  { value: "SETTLEMENT", label: "Settlement" },
  { value: "PAYMENT", label: "Payment" },
  { value: "MONTHLY-TRANSFER-FEE", label: "Monthly Transfer Fee" }
];
export const TransactionAccountTypeOptionsWithWallet = [
  { value: "REFUND", label: "Refund" },
  { value: "SETTLEMENT", label: "Settlement" },
  { value: "PAYMENT", label: "Payment" },
  { value: "WALLET", label: "Wallet" },
  { value: "MONTHLY-TRANSFER-FEE", label: "Monthly Transfer Fee" }
];
export const settlementStatusOptions = [
  { value: true, label: "Settled" },
  { value: false, label: "Un Settled" },
];

export const settlementStatusText = {
  settled: "Settled",
  unSettled: "Un Settled",
};
export const tagColorForSettlementStatus = {
  settled: "red",
  unSettled: "green",
};
export const TransactionAccountTypesText = {
  refund: "REFUND",
  settlement: "SETTLEMENT",
  qrPayment: "PAYMENT",
  externalPayment: "PAYMENT",
  wallet: "WALLET",
  "MONTHLY-TRANSFER-FEE": "MONTHLY TRANSFER FEE"
};
export const TransactionAccountTypesColor = {
  refund: "red",
  settlement: "red",
  qrPayment: "green",
  externalPayment: "green",
  wallet: "blue",
  "MONTHLY-TRANSFER-FEE": "purple"
};

export const InAppProductTypes = [
  { value: 14, label: "Airtime" },
  { value: 15, label: "Bill Payment" },
  // { value: 13, label: "Remittance" },
];
export const InappProducts = {
  airtime: 14,
  billPayment: 15,
  remittance: 13,
};
export const InAppAirtimeVendors = [
  { value: "TransferTo", label: "TransferTo" },
];

export const listBillpaymentVendors = ["Ayopop", "Ventaja",
  "bill avenue", "ventaja unified", "DTOne"]; //for excel and list request 

export const Vendors = {
  Ayopop: "Ayopop",
  Ventaja: "Ventaja",
  TransferTo: "TransferTo",
  billAvenue: "bill avenue",
  ventajaUnified: "ventajaUnified",
  ventajaunified: "ventaja unified",
  DTOne: "DT One",
};
export const InAppBillPaymentVendors = [
  { value: "", label: "All" },
  { value: "Ayopop", label: "Ayopop" },
  { value: "Ventaja", label: "Ventaja" },
  { value: "bill avenue", label: "Bill Avenue" },
  { value: "ventaja unified", label: "Ventaja Unified" },
  { value: "DTOne", label: "DT One" },
];


type KycDocumentTypes = Array<{ value: string, label: string }>;
export const KycDocumentTypes: KycDocumentTypes = [
  { value: 'WorkPermit', label: 'Work Permit' },
  { value: 'NRIC', label: 'NRIC' },
  { value: 'Passport', label: 'Passport' },
  { value: 'EP / DP', label: 'EP / DP' },
];
export const kycType = {
  jumio: "JUMIO",
  white: "WHITE",
  faceToface: "Face To Face",
  eKyc: "eKYC",
  onFido: "ONFIDO",
};
export const payoutTypeOptions = [
  { value: "C", label: "Cash Pickup" },
  { value: "B", label: "Bank Transfer" },
  { value: "D", label: "Account Deposit" },
  { value: "H", label: "Home Delivery" },
];

export const payoutTypes = {
  cashPickup: "C",
  bankTransfer: "B",
  accountDeposit: "D",
  mobileWallet: "M",
  homeDelivery: "H",
};
export const RemittanceDeliveryMethods = {
  banks: "banks",
  cashPickup: "cash_pickup",
  mobileWallet: "mwallets",
  homeDelivery: "home_deliver",
};
export const DeliveryMethodNames = {
  banks: "Bank Deposit",
  cashPickup: "Cash Pickup",
  mobileWallet: "Mobile Wallet",
  homeDelivery: "Home Deliver",
};
export const DeliveryMethodColor = {
  banks: "green",
  cashPickup: "purple",
  mobileWallet: "orange",
  homeDelivery: "blue",
};
export const DeliveryMethodOptions = [
  { value: "banks", label: "Bank Deposit" },
  { value: "cash_pickup", label: "Cash Pickup" },
  { value: "mwallets", label: "Mobile Wallet" },
  { value: "home_deliver", label: "Home Delivery" },
];
export const MessageTypes = [
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
  { value: 'push', label: 'Push' }
];
export const TopupParkingTypes = [
  { value: "processed", label: "Processed" },
  { value: "pending", label: "Pending" },
  { value: "removed", label: "Removed" },
];
export const topupLimit = {
  notDefined: "not_defined",
  residential: "residential",
  local: "local",
};
export const topupLimitText = {
  notDefined: "Not Defined",
  residential: "Residential",
  local: "Local",
};
export const parkingTypes = {
  topup: "topup",
  parking: "parking",
  refund: "refund",
};
export const topupParkingText = {
  topup: "Topup",
  parking: "Parking",
  refund: "Refund",
};
export const parkingHistoryTypes = {
  topup: "Topup",
  parking: "Parking",
  refund: "Refund",
  comment: "Comment",
  restore: "Restore",
  remove: "Remove",
};
export const AgentTransactionTypeText = {
  AddMoney: "Wallet Topup",
  Prefund: "Prefund",
  AgentSettlement: "Settlement",
  WalletUnload: "Wallet Unload",
  AddFund: "AddFund",
  ReturnFund: "ReturnFund"
};
export const AgentTransactionTypeOptions = [
  { value: 3, label: "Wallet Topup" },
  { value: 8, label: "Wallet Unload" },
  { value: 21, label: "Add Fund" },
  { value: 22, label: "Return Fund" },
  { value: 18, label: 'Voucher' },
  { value: 17, label: 'Issue' }
];
export const AgentTransactionStatusOptions = [
  { value: 2, label: "Order Accepted" },
  { value: 3, label: "Order Pending" },
  { value: 4, label: "Order Delivered" },
  { value: 5, label: "Order Rejected" },
  { value: 6, label: "Order Cancelled" },
];
export const OnFidoResultTypes = {
  clear: "clear",
  consider: "consider",
};
export const OnFidoStatusTypes = {
  complete: "complete",
  awaitingData: "awaiting_data",
};
export const commentsType = {
  Kyc: "kyc",
  Aml: "aml",
  addressProof: "address-proof",
  kycDetails: "kyc-details",
  screening: "screening",
  agentLedger: "agent-ledger",
  remittance: "remittance",
  merchantLedger: "merchant-ledger",
  merchantSettlement: "merchant-settlement",
  transaction: "transaction",
  User: "user",
};

export const remittanceProviders = {
  iPay: 1,
  jufu: 2,
  att: 3,
  jdee: 4,
  agrani: 5,
  flexRemit: 6,
  halong_pay: 7,
  ipay_your_pay: 8,
  mustafa_pay: 9
};
export const tagColorForremittanceProviders = {
  iPay: "green",
  jufu: "purple",
  att: "orange",
  jdee: "magenta",
  agrani: "green",
  flexRemit: "cyan",
  halong_pay: "blue",
  ipay_your_pay: "magenta",
  mustafa_pay: "orange"
};
// export const remittanceProvidersFields = [
//   { value: "iPay", label: "iPay" },
//   { value: "jufu", label: "jufu" },
//   { value: "att", label: "att" },
//   { value: "jdee", label: "jdee" },
//   { value: "agrani", label: "agrani" },
//   { value: "flexRemit", label: "flexRemit" },
//   { value: "halong_pay", label: "halong_pay" },
// ];

export const remitterVerficationStatus = {
  clear: true,
  blocked: false,
};
export const MerchantStatus = {
  active: 1,
  inActive: 0
};
export const remitterVerficationStatusText = {
  clear: "Cleared",
  blocked: "Blocked",
};
export const remitterVerficationStatusColor = {
  clear: "green",
  blocked: "red",
};
export const verificationStatus = [
  { value: true, label: "Cleared" },
  { value: false, label: "Blocked" },
];
export const OnfidoAMLName = {
  watchListStandard: "watchlist_standard",
  watchListEnhanced: "watchlist_enhanced",
};
export const attachmentTypes = {
  user: "user",
  kycDetails: "kyc-details",
  screening: "screening",
  addressDetails: "address-details",
  kycStatus: "kyc-status",
  kyc: "kyc",
  transaction: "transaction",
  merchant: "merchant",
  merchantSettlement: "merchant-settlement",
  providerSettlement: "provider-settlement",
  agent: "agent",
  agentLedger: "agent-ledger",
  membership: "membership-provider",
  userGuide: "user-guide",
  providerMerchantRequest: "provider-merchant-request",
  customer: 'customer',
  business: 'Business Onboarding'
};
export const dashboard = {
  "Default Dashboard": "default",
  "No Dashboard": "no-dashboard",
};
export const dashboardText = {
  "Default Dashboard": "Default",
  "No Dashboard": "No Dashboard",
};

export const PromoCodeTypeOptions = [
  { value: "Remittance-Service-Fee", label: "Remittance Service Fee" },
];
export const PromoCodeCalculationOptions = [
  { value: "Fixed", label: "Fixed" },
  { value: "Percentage", label: "Percentage" },
];
export const PromoCodeAppliesOptions = [
  { value: "Multiple", label: "Multiple" },
  { value: "Single", label: "Single" },
];

export const BulkTransactionValues = [
  "countryCode",
  "currency",
  "mobileNo",
  "amount",
  "accountNo",
];

export const BulkTransactionFields = [
  { value: "countryCode", label: "Country Code" },
  { value: "currency", label: "Currency" },
  { value: "mobileNo", label: "Mobile Number" },
  { value: "amount", label: "Amount" },
  { value: "accountNo", label: "Account Number" },
];

export const BulkCreditPointValues = [
  "countryCode",
  "mobileNo",
  "accountNo",
  "type",
  "expiryDate",
  "narration",
  "points"
];

export const BulkCreditPointFields = [
  { value: "countryCode", label: "Country Code" },
  { value: "mobileNo", label: "Mobile Number" },
  { value: "accountNo", label: "Account Number" },
  { value: "type", label: "Type" },
  { value: "expiryDate", label: "Expiry Date" },
  { value: "narration", label: "Narration" },
  { value: "points", label: "Points" },
  { value: "pointStatus", label: "Point values should not contain symbols" }
];

export const BulkCustomerValues = [
  "customerCode",
  "customerType",
  "clientId",
  "mobileNo",
  "countryCode",
  "displayName",
  "emailId",
  "fullName",
  "occupation",
  "firstName",
  "lastName",
  "middleName",
  "dob",
  "nationality",
  "gender",
  "addressLine1",
  "addressLine2",
  "city",
  "country",
  "zipcode",
  "natureOfBusiness",
  "province",
  "residentType",
  "ageRange"
];

export const MandatoryBulkCostomerValues = [
  "countryCode",
  "customerCode",
  "mobileNo",
  "natureOfBusiness",
  "firstName",
  "lastName",
  "displayName",
  "residentType",
  "province",
];

export const BulkCustomerFields = [
  { value: "customerCode", label: "Customer COde" },
  { value: "customerType", label: "Customer Type" },
  { value: "clientId", label: "Client Id" },
  { value: "mobileNo", label: "Mobile Number" },
  { value: "countryCode", label: "Country Code" },
  { value: "displayName", label: "Display Name" },
  { value: "fullName", label: "Full Name" },
  { value: "emailId", label: "Email Id" },
  { value: "occupation", label: "Occupation" },
  { value: "firstName", label: "First Name" },
  { value: "lastName", label: "Last Name" },
  { value: "middleName", label: "Middle Name" },
  { value: "dob", label: "DOB" },
  { value: "nationality", label: "Nationality" },
  { value: "gender", label: "Gender" },
  { value: "addressLine1", label: "Address Line 1" },
  { value: "addressLine2", label: "Address Line 2" },
  { value: "city", label: "City" },
  { value: "country", label: "Country" },
  { value: "zipcode", label: "Zip Code" },
  { value: "natureOfBusiness", label: "Nature of Business" },
  { value: "province", label: "Province" },
  { value: "residentType", label: "Resident Type" },
  { value: "ageRange", label: "Age Range" },
];

export const requestDetailsCodes = {
  onfidoKyc: "onfido_kyc",
  addRemitter: "create_remitter",
  uploadDocument: "upload_document_remitter",
  merchantSettlementRepost: "merchant_settlement_repost",
  merchantSettlementGetStatus: "merchant_settlement_getStatus",
};

export const apiTerminalForAudit = {
  backoffice: "admin",
  consumer: "consumer",
};
export const RewardPattern = {
  pattern: /^[0-9]*(\.[0-9]{0,2})?$/
}
//Rewards Points
export const RewardPointsCalculationOptions = [
  { value: "Fixed", label: "Fixed" },
  { value: "Multiple", label: "Multiple" },
];
export const RewardPointsCalculationType = {
  Fixed: "Fixed",
  Multiple: "Multiple",
};
export const RewardPointType = {
  Earn: 0,
  Burn: 1,
  Expired: 2,
  Debit: 3
};
export const RewardPointTypeColor = {
  Earn: "green",
  Burn: "orange",
  Expired: "red",
  Debit: "lime"
};
export const RewardPointTypeText = {
  Earn: "Earn",
  Burn: "Redeem",
  Expired: "Expired",
  Debit: "Debit"
};

//Rewards Points
export const RewardPointTransactionTypes = {
  SignUp: "SignUp",
  MerchantPay: "MerchantPay",
  Remittance: "Remittance",
  AirtimeTopup: "AirtimeTopup",
  WalletTopup: "WalletTopup",
  BillPayment: "BillPayment",
  WalletToWalletPay: "WalletToWalletPay",
};
//Need to remove (kesav)
export const RewardPointTransactionText = {
  SignUp: "SignUp",
  MerchantPay: "MerchantPay",
  Remittance: "Remittance",
  AirtimeTopup: "AirtimeTopup",
  WalletTopup: "WalletTopup",
  BillPayment: "BillPayment",
  WalletToWalletPay: "WalletToWalletPay",
};
export const RewardPointTransactionColor = {
  SignUp: "magenta",
  MerchantPay: "green",
  Remittance: "red",
  AirtimeTopup: "cyan",
  WalletTopup: "blue",
  BillPayment: "red",
  WalletToWalletPay: "orange",
};
export const RewardsOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
];

export const CustomPointTypeOptions = [
  { value: "earn", label: "Earn" },
  { value: "debit", label: "Debit" },
];
export const PointType = {
  earn: "earn",
  debit: "debit",
};
export const MerchantPayout = {
  object: "bank_account",
};
export const PaymentLogCode = {
  bankVerify: 'bank_verify',
  ayoopTransaction: "ayopop_payment",
  DTOnePayment: 'DT_One_Payment'
}
//Gift card Voucher
export const GiftVoucherStatus = {
  Expired: 1,
  Issued: 2,
  Redeemed: 3,
  Transferred: 4,
  Received: 5,
  PartiallyRedeemed: 6,
  Created: 7
};

export const GiftVoucherStatusColor = {
  Expired: "red",
  Issued: "blue",
  Redeemed: "green",
  Transferred: "volcano",
  Received: "purple",
  PartiallyRedeemed: "magenta",
  Created: "cyan",
};
export const GiftVoucherStatusText = {
  Expired: "Expired",
  Issued: "Issued",
  Redeemed: "Redeemed",
  Transferred: "Transferred",
  Received: "Received",
  PartiallyRedeemed: "PartiallyRedeemed",
  Created: "Created",
};
export const GenderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Prefer not to say", label: "Prefer not to say" },
  { value: "Others", label: "Others" }
];

export const merchantTypeOptions = [
  { value: "individual", label: "Individual" },
  { value: "company", label: "Company" },
];

export const businessTypeOptions = [
  { value: false, label: "QR Merchant" },
  { value: true, label: "Remittance Merchant" },
];

export const businessTypeOption2 = [
  { value: "QR Merchant", label: "QR Merchant" },
  { value: "Remittance Merchant", label: "Remittance Merchant" },
];

export const contactTypeOptions = [
  { value: "proprietor", label: "Proprietor" },
  { value: "director", label: "Director" },
  { value: "shareHolder", label: "Share Holder" },
  { value: "llp", label: "LLP" },
];

export enum SettlementBy {
  Flexm = "FlexM",
  Stripe = "Stripe"
}

export const SelectedSettlementByValue = 'FlexM';

export enum MerchantPaymentMethod {
  Wallet = "Wallet",
  PayNow = "PayNow",
  Card = "Card",
  GiftCard = "Gift Card",
  BankTransfer = "BankTransfer",
  Cash = "Cash",
  Cheque = "Cheque",
  Voucher = 'Voucher'
}

export const MerchantPaymentMethods = {
  Wallet: "Wallet",
  PayNow: "PayNow",
  Card: "Card",
  GiftCard: "Gift Card",
  BankTransfer: "BankTransfer",
  Cash: "Cash",
  Cheque: "Cheque",
  Voucher: 'Voucher',
  Eleven: "7Eleven",
  topupParking: 'Topup-Parking'
}

export const PaymentMethodColor = {
  Wallet: "blue",
  PayNow: "purple",
  Card: "magenta",
  GiftCard: "volcano",
  BankTransfer: "geekblue",
  Cash: "green",
  Cheque: "green",
  Eleven: "cyan",
  Voucher: 'yellow',
  topupParking: 'volcano'
}

export const RoutingNoData = {
  countryId: 50
}

export const IFSCCodeData = {
  countryId: 356
}
export const MoneyExchangeData = {
  countryId: 356
}
export const imageUploadType = {
  user: "user",
  transaction: "transaction",
  merchant: "merchant",
  kyc: "kyc",
  screening: "screening",
  kycdetails: "kyc-details",
  kycStatus: "kyc-status",
  addressDetails: "address-details",
  remittance: "remittance",
  merchantSettlement: "merchant-settlement",
  merchantImage: "merchant-image",
  merchantImageStripe: 'merchantImage',
  kycImage: "kyc-image",
  membershipImage: "membership-provider",
  voucher: 'voucher',
  voucherProfileImage: 'voucher-profile-image',
  voucherAdditionalImage: 'voucher-additional-image',
  customerProfile: 'customer-profile-image'
}

export const imageListType = ["card-logo", "card-design"];
export const attachmentListType = ["platform-client-logo", "platform-client-profile-picture"];
export const attachmentCustomer = ["customer-profile-image"];

export const merchantStatus = [
  { label: "Approved", value: "approved" },
  { label: "Not approved", value: "notapproved" },
];
export const imageUploadCode = {
  idDocuments: "id-documents",
  proof_docs: "proof_docs",
  reference_files: "reference_files",
  cover_image: "cover_image",
  profile_image: "profile_image",
  logo_image: "logo_image",
  liveness_images: "greeliveness_imagesn",
  address_proof_images: "address_proof_images",
  id_document_images: "id_document_images",
  attachment: "attachment",
  provider_settlement: "provider-settlement",
  onboardingDocuments: "onboarding-document",
}

export const ImageType = {
  MerchantImage: 'merchantImage'
}

export const providerId =
{
  Ayopop: 1,
  Ventaja: 2,
  billAvenue: 3,
  ventajaUnified: 4,
  DTOne: 5
}

export const providerIdOptions = [
  { value: 0, label: "All" },
  { value: 1, label: "Ayopop" },
  { value: 2, label: "Ventaja" },
  { value: 3, label: "Bill Avenue" },
  { value: 4, label: "Ventaja Unified" },
  { value: 5, label: "DT One" }
];

export const productTypeAllOptions = [
  { value: '', label: "All" },
  { value: 'prepaid', label: "Prepaid" },
  { value: 'postpaid', label: "Postpaid" },
  { value: 'government services', label: "Government Services" },
  { value: 'utility services', label: "Utility Services" },
];

export const productTypeOptions = [
  { value: 'prepaid', label: "Prepaid" },
  { value: 'postpaid', label: "Postpaid" },
  { value: 'government services', label: "Government Services" },
  { value: 'utility services', label: "Utility Services" },
];

type ContactKycDocumentTypes = Array<{ value: string; label: string }>;
export const ContactKycDocumentTypes: ContactKycDocumentTypes = [
  { value: "WorkPermit", label: "Work Permit" },
  { value: "NRIC", label: "NRIC" },
  { value: "Passport", label: "Passport" },
];
export const documentType = [
  { value: "account_requirement", label: "Account Requirement" },
  { value: "additional_verification", label: "Additional Verification" },
  { value: "identity_document", label: "Identity Document" }
];
export const logOptions = [
  { value: "mobile_no", label: "Mobile No" },
  // { value: "account_no", label: "Account No" },
  { value: "emailId", label: "Email ID" }
];
export const walletOptions = [
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" }

];
export const logsPaymentStatus = {
  bank_verify: 'bank_verify'
};
//Notifications Message Types
export const NotificationsMessageTypes = {
  Email: "email",
  SMS: "sms",
  Push: "Push"
};
export const NotificationsMessageText = {
  Email: "Email",
  SMS: "SMS",
  Push: "Push"
};
export const NotificationsMessageColor = {
  Email: "magenta",
  SMS: "green",
  Push: "cyan",
};
export const activeUsersOptions = [
  { value: "displayName", label: "Name" },
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" }
];
export const userReportOptions = [
  { value: "displayName", label: "Name" },
  { value: "mobile_no", label: "Mobile No" },
];
export const activeUsersDateFilterOptions = [
  { label: "Created On", value: "created_Date" },
  { label: "Last Login", value: "last_Login" }
];
export const UserSignatureStatus = {
  Locked: 0,
  Unlocked: 1

};
export const UserSignatureStatusText = {
  Locked: "Locked",
  Unlocked: "Unlocked"

};
export const UserSignatureStatusColor = {
  Locked: "red",
  Unlocked: "green"


};
export const UserSignatureLogStatus = {
  Failure: 0,
  Success: 1

};
export const UserSignatureLogStatusText = {
  Failure: "Failure",
  Success: "Success"

};
export const UserSignatureLogStatusColor = {
  Failure: "red",
  Success: "green"


};
// UserTypes
export const UserTypes = {
  admin: "admin",
  merchant: "merchant",
  appUser: "appuser",
  locationUser: "location-user",
  locationManager: "location-manager",
  agent: "agent",
  kycBoardUser: "kyc-board-user",
};
export const UserTypeText = {
  admin: "Admin",
  merchant: "Merchant",
  appUser: "App User",
  locationUser: "Location User",
  locationManager: "Location Manager",
  agent: "Agent",
  kycBoardUser: "KYC Board User",
};
export const UserTypeColor = {
  admin: "magenta",
  merchant: "cyan",
  appUser: "green",
  locationUser: "purple",
  locationManager: "blue",
  agent: "orange",
  kycBoardUser: "purple",
};

// Webhooks 

export const WebhookTypes = {
  walletWebhook: "wallet_webhook",
  transactionWebhook: "transaction_webhook",
  kycWebhook: "kyc_webhook",
};
export const webhookTypeOptions = [
  { value: 'wallet_webhook', label: "Wallet Webhook" },
  { value: 'transaction_webhook', label: "Transaction Webhook" },
  { value: 'kyc_webhook', label: "Kyc Webhook" }

];
export const UsersRole = {
  admin: "admin",
  kycBoardUser: "kycBoardUser",
};
export const logsWebhooksUrls = {
  webhooks: 'webhooks',
  logs: 'logs',
};
export const UserWebhookTypeText = {
  walletWebhook: "Wallet Webhook",
  transactionWebhook: "Transaction Webhook",
  kycWebhook: "KYC Webhook",
};
export const UserWebhookTypeColor = {
  walletWebhook: "magenta",
  transactionWebhook: "green",
  kycWebhook: "blue"
};
export const MerchantTypes = {
  individual: "individual",
  company: "company",
};
export const MerchantTypesText = {
  individual: "Individual",
  company: "Company",
};
export const MerchantTypesColor = {
  individual: "magenta",
  company: "cyan",
};
export const periodsDateFilterOptions = [
  { label: "Created On", value: "created_Date" },
  { label: "Monthly", value: "monthly" },
  { label: "Half Year", value: "half-year" },
  { label: "Annual", value: "annual" }
];
export const activeLocationStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" }
]
export const MembershipStatus = {
  Active: 1,
  InActive: 2
};
export const MembershipStatusText = {
  Active: "Active",
  InActive: "In Active",
};
export const membershipStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" }
];
export const MerchantRequestStatusOptions = [

  // { value: 0, label: "Deleted" },
  { value: 1, label: "Requested" },
  { value: 2, label: "Created" },
  { value: 3, label: "Duplicate" },
  { value: 4, label: "KIV" },
  { value: 5, label: "Compliance Approval" },
  { value: 6, label: "Production" },
  { value: 7, label: "Ready for Activation" },
  { value: 8, label: "Active" },
  { value: 9, label: "In Active" },

];
export const MerchantRequestStatus = {
  // Deleted: 0,   status deleted is not having in grid after delete,so can't able to filter status deleted
  Requested: 1,
  Created: 12,
  Duplicate: 3,
  KIV: 4,
  Compliance_Approval: 5,
  Production: 6,
  Ready_for_Activation: 7,
  Active: 8,
  InActive: 9
};
export const MerchantRequestStatusColor = {
  // Deleted: "red",
  Requested: "yellow",
  Created: "purple",
  Duplicate: "blue",
  KIV: "magenta",
  Compliance_Approval: "cyan",
  Production: "orange",
  Ready_for_Activation: "volcano",
  Active: 'green',
  InActive: 'red'
};

export const MerchantRequestStatusText = {
  // Deleted: "Deleted",
  Requested: "Requested",
  Created: "Created",
  Duplicate: "Duplicate",
  KIV: "KIV",
  Compliance_Approval: "Compliance Approval",
  Production: "Production",
  Ready_for_Activation: "Ready for Activation",
  Active: 'Active',
  InActive: 'In Active'
};
export const MerchantRequestType = {
  Merchant: 1,
  Branch: 2

};
export const MerchantRequestTypeColor = {
  Merchant: "purple",
  Branch: "magenta"

};
export const MerchantRequestTypeText = {
  Merchant: "Merchant",
  Branch: "Branch"

};
export const MerchantRequestTypeOptions = [
  { label: "Merchant", value: 1 },
  { label: "Branch", value: 2 }
];
// Membership Users
export const MembershipUserStatus = {
  active: 1,
  inactive: 2,
  suspend: 10
};
export const MembershipUserStatusText = {
  active: "Active",
  inactive: "In Active",
  suspend: "Suspended",

};
export const MembershipUserStatusColor = {
  active: "green",
  inactive: "red",
  suspend: "magenta",

};
export const MembershipUserStatusOptions = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'Inactive' },
  { value: 10, label: 'Suspend' },
];


export const Merchant = {
  qrMerchant: "QR Merchant",
  remittanceMerchant: "Remittance Merchant",
};
export const DomesticPeriodsDateFilterOptions = [
  { label: "Created On", value: "created_Date" },
  { label: "Monthly", value: "monthly" },
  { label: "Half Year", value: "half-year" }
];
export const DomesticTransactionTypeOptions = [
  { value: 2, label: "Send Money" },
  { value: 3, label: "Add Money" },
  { value: 4, label: "Merchant Pay" },
  { value: 6, label: "Refund" },
  { value: 8, label: "Wallet Unload" },
  { value: 11, label: "Transfer Fee" },
  { value: 12, label: "Wallet Close" },
  { value: 14, label: "AirtimeTopup" },
  { value: 15, label: "BillPayment" },
  { value: 23, label: "ClientRemittance" },

];
export const CurrencyCode = {
  php: "PHP",
  sgd: "SGD",
};
export const PayoutMethods = {
  Bank: "Bank",
  CashPickup: "CashPickup"
};

export enum JobHTTPMethod {
  HTTP_METHOD_UNSPECIFIED = 0,
  POST = 1,
  GET = 2,
  HEAD = 3,
  PUT = 4,
  DELETE = 5,
  PATCH = 6,
  OPTIONS = 7,
};

export const JobMethodOptions = [
  { label: "HTTP_METHOD_UNSPECIFIED", value: 0 },
  { label: "POST", value: 1 },
  { label: "GET", value: 2 },
  { label: "HEAD", value: 3 },
  { label: "PUT", value: 4 },
  { label: "DELETE", value: 5 },
  { label: "PATCH", value: 6 },
  { label: "OPTIONS", value: 7 }
];

export const Method = {
  HTTP_METHOD_UNSPECIFIED: 0,
  POST: 1,
  GET: 2,
  HEAD: 3,
  PUT: 4,
  DELETE: 5,
  PATCH: 6,
  OPTIONS: 7,
};
export const MethodTypeText = {
  HTTP_METHOD_UNSPECIFIED: "Http Method Unspecified",
  POST: "Post",
  GET: "Get",
  HEAD: "Head",
  PUT: "Put",
  DELETE: "Delete",
  PATCH: "Patch",
  OPTIONS: "Options",
};
export const MethodColor = {
  HTTP_METHOD_UNSPECIFIED: "magenta",
  POST: "cyan",
  GET: "green",
  HEAD: "red",
  PUT: "blue",
  DELETE: "orange",
  PATCH: "gold",
  OPTIONS: "purple",
};

export const jobTypeOptions = [
  { value: 'MERCHANT_SETTLEMENT', label: "Merchant Settlement" },
  { value: 'LOCATION_SETTLEMENT', label: "Location Settlement" },
  { value: 'MEMBERSHIP_PROVIDER_SETTLEMENT', label: "Membership Provider Settlement" },
  { value: 'BANK_TRANSFER_SETTLEMENT', label: "Bank Transfer Settlement" },
  { value: 'MERCHANT_MONTHLY_TRANSFER_FEE', label: "Merchant monthly transfer fee" }
];

export const jobType = {
  'MERCHANT_SETTLEMENT': 'MERCHANT_SETTLEMENT',
  'MERCHANT_LOCATION_SETTLEMENT': 'MERCHANT_LOCATION_SETTLEMENT',
  'TRANSACTION_FEE_SETTLEMENT': 'TRANSACTION_FEE_SETTLEMENT',
  'BANK_TRANSFER_SETTLEMENT': 'BANK_TRANSFER_SETTLEMENT',
  'LOCATION_SETTLEMENT': 'LOCATION_SETTLEMENT',
  'MEMBERSHIP_PROVIDER_SETTLEMENT': 'MEMBERSHIP_PROVIDER_SETTLEMENT',
  'MERCHANT_MONTHLY_TRANSFER_FEE': 'MERCHANT_MONTHLY_TRANSFER_FEE'
};

export const JobTypeText = {
  MERCHANT_SETTLEMENT: 'MERCHANT SETTLEMENT',
  MERCHANT_LOCATION_SETTLEMENT: 'MERCHANT LOCATION SETTLEMENT',
  TRANSACTION_FEE_SETTLEMENT: 'TRANSACTION FEE SETTLEMENT',
  BANK_TRANSFER_SETTLEMENT: 'BANK TRANSFER SETTLEMENT',
  LOCATION_SETTLEMENT: 'LOCATION SETTLEMENT',
  MEMBERSHIP_PROVIDER_SETTLEMENT: 'MEMBERSHIP PROVIDER SETTLEMENT',
  MERCHANT_MONTHLY_TRANSFER_FEE: 'MERCHANT MONTHLY TRANSFER FEE',
};

export const JobTypeColor = {
  MERCHANT_SETTLEMENT: 'green',
  MERCHANT_LOCATION_SETTLEMENT: 'cyan',
  TRANSACTION_FEE_SETTLEMENT: 'red',
  BANK_TRANSFER_SETTLEMENT: 'purple',
  MEMBERSHIP_PROVIDER_SETTLEMENT: 'blue',
  LOCATION_SETTLEMENT: 'orange',
  MERCHANT_MONTHLY_TRANSFER_FEE: 'red',
};

export const targetOptions = [
  { value: '/merchant/settlement/job', label: "/merchant/settlement/job" },
  { value: '/backoffice/test/job/post2', label: "/backoffice/test/job/post" },
  { value: '/backoffice/test/job/post3', label: "/backoffice/test/job/post" },
  { value: '/merchant/bank-transfer/settlement/job', label: "/merchant/bank-transfer/settlement/job" },
  { value: '/membership-provider/settlement/job', label: "/membership-provider/settlement/job" },
  { value: '/location/settlement/job', label: "/location/settlement/job" },
  { value: '/merchant/monthly-transfer-fee/job', label: "/merchant/monthly-transfer-fee/job" },
];

export const JobMethodPopulate = {
  MERCHANT_SETTLEMENT: 0,
  MERCHANT_LOCATION_SETTLEMENT: 1,
  TRANSACTION_FEE_SETTLEMENT: 3,
  BANK_TRANSFER_SETTLEMENT: 1,
  LOCATION_SETTLEMENT: 1,
  MEMBERSHIP_PROVIDER_SETTLEMENT: 1,
  MERCHANT_MONTHLY_TRANSFER_FEE: 1
};

export const targetPopulate = {
  MERCHANT_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/merchant/settlement/job',
  MERCHANT_LOCATION_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/backoffice/test/job/post2',
  TRANSACTION_FEE_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/backoffice/test/job/post2',
  BANK_TRANSFER_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/merchant/bank-transfer/settlement/job',
  LOCATION_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/merchant/location/settlement/job',
  MEMBERSHIP_PROVIDER_SETTLEMENT: 'https://ffp3admin-api-dev.flexm.com/membership-provider/settlement/job',
  MERCHANT_MONTHLY_TRANSFER_FEE: 'https://ffp3admin-api-dev.flexm.com/merchant/monthly-transfer-fee/job',
};

export const JobStatusOptions = [
  { label: "Deleted", value: 0 },
  { label: "Active", value: 1 },
  { label: "Error", value: 2 },
  { label: "Created", value: 3 },
  { label: "NotCreated", value: 4 },
  { label: "Paused", value: 5 },
];

export const JobStatus = {
  Deleted: "0",
  Active: "1",
  Error: "2",
  Created: "3",
  NotCreated: "4",
  Paused: "5",

};
export const JobStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  Error: "Error",
  Created: "CreatedHead",
  NotCreated: "Not Created",
  Paused: "Paused",
};

export const JobStatusColor = {
  Deleted: "magenta",
  Active: "green",
  Error: "red",
  Created: "cyan",
  NotCreated: "blue",
  Paused: "orange",
};
export const PortalType = {
  AdminBoard: 'adminboard',
  RemitanceBoard: 'remitanceboard',
  KycBoard: 'kycboard',
  MerchantBoard: 'merchantboard',
  AgentBoard: 'agentboard',

};
export const PortalTypeText = {
  AdminBoard: 'Admin Board',
  RemitanceBoard: 'Remitance Board',
  KycBoard: 'KYC Board',
  MerchantBoard: 'Merchant Board',
  AgentBoard: 'Agent Board',
};

export const PortalTypeColor = {
  AdminBoard: "magenta",
  RemitanceBoard: "green",
  KycBoard: "red",
  MerchantBoard: "cyan",
  AgentBoard: "blue"
};

export const portalTypeOptions = [
  { label: "Admin Board", value: 'adminboard' },
  { label: "Remitance Board", value: 'remitanceboard' },
  { label: "KYC Board", value: 'kycboard' },
  { label: "Merchant Board", value: 'merchantboard' },
  { label: "Agent Board", value: 'agentboard' },
];

export const scrollTypeOptions = [
  { label: "None", value: "none" },
  { label: "Horizontal", value: "horizontal" },
  { label: "Vertical", value: "vertical" },
];
export const locationTypeOption = [
  { label: "Screen", value: "screen" },
  { label: "Popup", value: "popup" },
];

export const bannerTypeOptions = [
  { label: "Module", value: "module" },
  { label: "Popup", value: "popup" },
  { label: "URL", value: "url" },
];

export const location = {
  Screen: "screen",
  Popup: "popup",
};
export const locationText = {
  Screen: "screen",
  Popup: "popup",
};
export const locationColor = {
  Screen: "cyan",
  Popup: "orange",
};
export const scrollType = {
  None: "none",
  Horizontal: "horizontal",
  Vertical: "vertical",
};

export const scrollTypeText = {
  None: "None",
  Horizontal: "Horizontal",
  Vertical: "Vertical",
};

export const scrollTypeColor = {
  None: "magenta",
  Horizontal: "cyan",
  Vertical: "orange",
};

export const imageType = {
  Module: "module",
  Popup: "popup",
  URL: "url",
};

export const imageTypeText = {
  Module: "Module",
  Popup: "Popup",
  URL: "URL",
};

export const imageTypeColor = {
  Module: "green",
  Popup: "purple",
  URL: "blue",
};
export const CorrespondentStatus = {
  Active: 1,
  InActive: 2,
  Deleted: 0
};
export const CorrespondentStatusColor = {
  Active: "green",
  InActive: "red"
};
export const CorrespondentStatusText = {
  Active: "Active",
  InActive: "InActive"
};
export const CorrespondentStatusOptions = [
  { value: 1, label: 'Active' },
  { value: 0, label: 'InActive' },
];
export const serviceNameOptions = [
  { label: "Pesonet", value: "pesonet" },
  { label: "Instapay", value: "instapay" },
  { label: "Within", value: "within" },
];
export const serviceName = {
  pesonet: "pesonet",
  instapay: "instapay",
  within: "within",
};

export const serviceNameText = {
  pesonet: "Pesonet",
  instapay: "Instapay",
  within: "Within",
};

export const serviceNameColor = {
  pesonet: "magenta",
  instapay: "cyan",
  within: "orange",
};

export const CardTypeNetworkOptions = [
  { label: 'Visa', value: 'visa' },
  { label: 'Master', value: 'master' },
  { label: 'Dollar', value: 'dollar' },
  { label: 'American Express', value: 'ameri' },
];

export const CardTypeNetwork = {
  Visa: 'visa',
  Master: 'master',
  Dollar: 'dollar',
  AmericanExpress: 'ameri'
};
export const CardTypeNetworkColor = {
  Visa: 'red',
  Master: 'orange',
  Dollar: 'blue',
  AmericanExpress: 'green'

};
export const CardTypeNetworkText = {
  Visa: 'Visa',
  Master: 'Master',
  Dollar: 'Dollar',
  AmericanExpress: 'American Express'
};

export const CardTypeTypeOptions = [
  { label: 'Platinum', value: 'platinum' },
  { label: 'Gold', value: 'gold' },
  { label: 'Flex Rewards', value: 'flex-rewards' },
];

export const CardTypeType = {
  Platinum: 'platinum',
  Gold: 'gold',
  flexRewards: 'flex-rewards',
};
export const CardTypeTypeColor = {
  Platinum: 'cyan',
  Gold: 'yellow',
  flexRewards: 'green',
};
export const CardTypeTypeText = {
  Platinum: 'Platinum',
  Gold: 'Gold',
  flexRewards: 'Flex Rewards',
};

export const CardTypeGeneOptions = [
  { label: 'Debit', value: 'debit' },
  { label: 'Prepaid', value: 'prepaid' },
];

export const CardTypeGene = {
  Debit: 'debit',
  Prepaid: 'prepaid'
};
export const CardTypeGeneColor = {
  Debit: 'purple',
  Prepaid: 'cyan'
};
export const CardTypeGeneText = {
  Debit: 'Debit',
  Prepaid: 'Prepaid'
};

export const CardTypeAvailabilityOptions = [
  { label: 'Virtual', value: 'virtual' },
  { label: 'Physical', value: 'physical' },
];

export const CardTypeAvailability = {
  Virtual: 'virtual',
  Physical: 'physical',
};
export const CardTypeAvailabilityColor = {
  Virtual: 'blue',
  Physical: 'cyan',
};
export const CardTypeAvailabilityText = {
  Virtual: 'Virtual',
  Physical: 'Physical',
};

export const CardStatusOptions = [
  { label: 'Issued', value: 'issued' },
  { label: 'Not Issued', value: 'not-issued' }
];

export const CardStatus = {
  Issued: 'issued',
  NotIssued: 'not-issued',
};
export const CardStatusColor = {
  Issued: 'green',
  NotIssued: 'red',
};
export const CardStatusText = {
  Issued: 'Issued',
  NotIssued: 'Not Issued',
};
export const AccountCardStatusOptions = [
  { label: 'Not Active', value: 'not-active' },
  { label: 'Active', value: 'active' },
  { label: 'Blocked', value: 'blocked' },
  { label: 'Replaced', value: 'replaced' },
  { label: 'Expired', value: 'expired' },
  { label: 'Closed', value: 'closed' },
  { label: 'Unblock', value: 'unblock' },



];

export const AccountCardStatus = {
  NotActive: 'not-active',
  Active: 'active',
  Blocked: 'blocked',
  Replaced: 'replaced',
  Expired: 'expired',
  Closed: 'closed',
  Unblock: 'unblock'
};
export const AccountCardStatusColor = {
  NotActive: 'red',
  Active: 'green',
  Blocked: 'orange',
  Replaced: 'blue',
  Expired: 'magenta',
  Closed: 'cyan',
  Unblock: 'purple',

};
export const AccountCardStatusText = {
  NotActive: 'Not Active',
  Active: 'Active',
  Blocked: 'Blocked',
  Replaced: 'Replaced',
  Expired: 'Expired',
  Closed: 'Closed',
  Unblock: 'Unblock',

};
export const cvcTypeOptions = [
  { label: 'Static', value: 'static' },
  { label: 'Dynamic', value: 'dynamic' },
];

export const cvcType = {
  Static: 'static',
  Dynamic: 'dynamic',
};
export const cvcTypeColor = {
  Static: 'blue',
  Dynamic: 'cyan',
};
export const cvcTypeText = {
  Static: 'Static',
  Dynamic: 'Dynamic',
};

export const BinCardMonthOptions = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const BinCardMonths = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,

};

export const BinCardMonthsText = {
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
};

export const CountryForBinCard = [{
  currency: "SGD",
  name: "Singapore",
  symbol: "$",
}];


export const CardBinProviderModel = 'flexm_test';
export const NotificationType = {
  SMS: "SMS",
  PUSH: "PUSH",
  PUSH_TITLE: "PUSH_TITLE",
  EMAIL: "EMAIL",
  EMAIL_SUBJECT: "EMAIL_SUBJECT"

};
export const NotificationTypeText = {
  SMS: "SMS",
  PUSH: "PUSH",
  PUSH_TITLE: "PUSH TITLE",
  EMAIL: "EMAIL",
  EMAIL_SUBJECT: "EMAIL SUBJECT"
};

export const NotificationTypeColor = {
  SMS: "magenta",
  PUSH: "green",
  PUSH_TITLE: "red",
  EMAIL: "cyan",
  EMAIL_SUBJECT: "blue"
};

export const NotificationTypeOptions = [
  { label: "SMS", value: 'SMS' },
  { label: "PUSH", value: 'PUSH' },
  { label: "PUSH TITLE", value: 'PUSH_TITLE' },
  { label: "EMAIL", value: 'EMAIL' },
  { label: "EMAIL SUBJECT", value: 'EMAIL_SUBJECT' },
];


export const voucherTypeOptions = [
  { label: "Cash", value: "cash" },
  { label: "Merchant", value: "merchant" },
];

export const voucherType = {
  Cash: "cash",
  Merchant: "merchant",
};

export const voucherTypeText = {
  Cash: "Cash",
  Merchant: "Merchant",
};

export const voucherTypeColor = {
  Cash: "cyan",
  Merchant: "orange",
};


export const purchaseTypeOptions = [
  { label: "Points", value: "points" },
  { label: "Price", value: "price" },
  { label: "Free", value: "free" },
  { label: "Display", value: "display" },
];

export const purchaseType = {
  Points: "points",
  Price: "price",
  Free: "free",
  Display: "display",
};

export const purchaseTypeText = {
  Points: "Points",
  Price: "Price",
  Free: "Free",
  Display: "Display",
};

export const purchaseTypeColor = {
  Points: "magenta",
  Price: "green",
  Free: "orange",
  Display: "blue"
};

export const prefundOptions = [
  { label: "Prefund", value: true },
  { label: "Settlement", value: false },
];

export const MerchantFund = {
  Prefund: true,
  Settlement: false
};
export const MerchantFundText = {
  Prefund: "Prefund",
  Settlement: "Settlement"
};
export const MerchantFundColor = {
  Prefund: "purple",
  Settlement: "lime"
};

export const NotificationTemplateDefaultLanguage = 'en';
export const TransactionStatus = {
  Failed: 0,
  Success: 1

};
export const TransactionText = {
  Failed: "Failed",
  Success: "Success"

};
export const TransactionColor = {
  Failed: "red",
  Success: "green"
};
export const TransactionSettlementStatus = {
  unsettled: 0,
  settled: 1,
};
export const TransactionSettlementStatusColor = {
  unsettled: "red",
  settled: "green",
};
export const TransactionSettlementStatusText = {
  unsettled: "Unsettled",
  settled: "Settled",
};
export const IpAddressValidation = {
  // tslint:disable-next-line: max-line-length
  ipaddressRegex:
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
};

export const VoucherValues = [
  "Sno",
  "VoucherCode",
];
export const VoucherBulkValues = [
  "Sno",
  "accountNo",
];
export const VoucherFields = [
  { value: "Sno", label: "Sl No" },
  { value: "VoucherCode", label: "Voucher Code" }
];

export const VoucherCreateOptions = [
  { label: "Upload CSV", value: 'csv' },
  { label: "Generate Voucher Codes", value: 'generate' },
];

export const VoucherCreateType = {
  csv: "csv",
  generate: "generate",
};

export const bulkIssuanceOptions = [
  { label: "Upload CSV", value: 'csv' },
  { label: "Manual", value: 'manual' },
];

export const bulkIssuanceType = {
  csv: "csv",
  manual: "manual",
};

export const voucherStatusText = {
  Deleted: "Deleted",
  Active: "Active",
  InActive: "In Active",
  NotIssued: "Not Issued",
  Expired: "Expired",
  Redeemed: "Redeemed",
};

export const voucherStatusColor = {
  Deleted: "magenta",
  Active: "green",
  InActive: "red",
  NotIssued: "orange",
  Expired: "red",
  Redeemed: "cyan",
};

export const VoucherStatus = {
  Deleted: 0,
  Active: 1,
  InActive: 2,
  NotIssued: 3,
  Expired: 4,
  Redeemed: 5,
};

export const voucherStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 3, label: "Not Issued" },
  { value: 4, label: "Expired" },
  { value: 5, label: "Redeemed" },
];


export const voucherStatusOptions2 = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 3, label: "Not Issued" },
];

export const pregeneratedOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const voucherCodeStatus = {
  redeemed: "redeemed",
  active: "active",
  inactive: "inactive",
  notissued: "notissued",
  expired: "expired"
};

export const voucherCodeStatusColor = {
  redeemed: "cyan",
  active: "green",
  inactive: "red",
  notissued: "orange",
  expired: "magenta"
};

export const voucherStatusCodeText = {
  redeemed: "Redeemed",
  active: "Active",
  inactive: "In Active",
  notissued: "Not Issued",
  expired: "Expired"
};
export const form4UserStatusOptions = [
  { value: 1, label: "Active" },
  { value: 7, label: "Blocked" },
  { value: 6, label: "Closure Requested" },
  // { value: 0, label: "Deleted" },
  { value: 2, label: "In Active" },
  { value: 4, label: "In Review" },
  // { value: 3, label: "Locked" },
  { value: 5, label: "Un Flagged" },
];
export const statusForMerchants = {
  Active: 1,
  InActive: 2,
};
export const statusMerchantColor = {
  Active: 'green',
  InActive: 'red',
};
export const statusMerchantText = {
  Active: 'Active',
  InActive: 'In Active',
};
export const merchantStatusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" }
];
export const dateRangeOptions = [
  { value: "createdDate", label: "Created Date" },
  { value: "voucherDate", label: "Voucher Date" },
];
export const dateRangeType = {
  createdDate: "createdDate",
  voucherDate: "voucherDate",
};
export const UserAndModuleType = {

  admin: "Admin",
  kyc: "KYC",
  agent: "Agent",
  merchant: "Merchant",
  remittance: "Remittance",
  business: "Business"


}

export const UserAndModuleTypeOptions = [
  { value: "Admin", label: "Admin user" },
  { value: "KYC", label: "KYC board user" },
  { value: "Agent", label: "Agent board user" },
  { value: "Merchant", label: "Merchant board user" },
  { value: "Remittance", label: "Remittance board user" },
  { value: "Business", label: "Business board user" },
];
export const crpType = {
  numberRange: "numberRange",
  keyPair: "keyPair",
  stringArray: "stringArray",
  string: "string",
  number: "number"
};
export const OverRideText = {
  true: "Enabled",
  false: "Disabled"
}
export const overRideColor = {
  true: "green",
  false: "red"
}
export const crpTypeColor = {
  numberRange: "cyan",
  keyPair: "green",
  stringArray: "red",
  string: "orange",
  number: "magenta"
};

export const crpTypeText = {
  numberRange: "Number Range",
  keyPair: "Key Pair",
  stringArray: "String Array",
  string: "String",
  number: "Number"
};
export const RiskParameterTypeOptions = [
  { value: "numberRange", label: "Number Range" },
  { value: "keyPair", label: "Key Pair" },
  { value: "stringArray", label: "String Array" },
  { value: "string", label: "String" },
  { value: "number", label: "Number" },

];

export const allActiveUsersFilterOptions = [
  { value: "mobile_no", label: "Mobile Number" },
  { value: "fullName", label: "Full Name" },
  { value: "account_no", label: "Account No" },
  { value: "documentNumber", label: "ID Number" },
  { value: "dob", label: "Date of Birth" }
];

export const categoryTemp = {
  walletCreate: 'WALLET CREATE',
  walletTransfer: 'Wallet Transfer'
};

export const environmentTypeOptions = [
  { label: "Dev", value: "Dev" },
  { label: "AdbUat", value: "AdbUat" },
  { label: "Uat", value: "Uat" },
  { label: "Prod", value: "Prod" },
  { label: "PHProd", value: "PHProd" },

];

export const environmentType = {
  Dev: "Dev",
  AdbUat: "AdbUat",
  Uat: "Uat",
  Prod: "Prod",
  PHProd: "PHProd",

};

export const environmentTypeText = {
  Dev: "Dev",
  AdbUat: "AbdUat",
  Uat: "Uat",
  Prod: "Prod",
  PHProd: "PHProd",
};

export const environmentTypeColor = {
  Dev: "magenta",
  AdbUat: "green",
  Uat: "orange",
  Prod: "blue",
  PHProd: "red",
};

export const providerName = {
  onewaysms: 'onewaysms',
  dovesms: 'dovesms',
  twilio: 'twilio'
};

export const providerIds = [
  { value: 1, label: "One Way Sms" },
  { value: 2, label: "Dove Sms" },
  { value: 3, label: "Twilio" }
]

export const SMSProvidersText = {
  1: "One Way Sms",
  2: "Dove Sms",
  3: "Twilio"
}

export const SMSProvidersTextColor = {
  1: "magenta",
  2: "orange",
  3: "blue"
}

export const providerText = {
  onewaysms: "One Way Sms",
  dovesms: "Dove Sms",
  twilio: "Twilio"
};
export const providerColor = {
  onewaysms: "magenta",
  dovesms: "orange",
  twilio: "blue"
};
export const DocumentDirectorType = [
  { value: 'NRIC', label: 'NRIC' },
  { value: 'Passport cum Local Address Proof', label: 'Passport cum Local Address Proof' }
];
export const DocumentType = [
  { value: 'NRIC', label: 'NRIC' },
  { value: 'Passport cum Local Address Proof', label: 'Passport cum Local Address Proof' }
];
export const DocumentCanadaType = [
  { value: 'PR Card', label: 'PR Card' },
  { value: 'Driving License', label: 'Driving License' }
];

export const platformDevice = [
  { value: 'Android', label: 'Android' },
  { value: 'iOS', label: 'iOS' },
  { value: 'Web', label: 'Web' }
];
export const existingScheme = [
  { value: 'SGQR', label: 'SGQR' },
  { value: 'PayNow', label: 'PayNow' },
  { value: 'NETS', label: 'NETS' },
  { value: 'Credit Cards', label: 'Credit Cards' },
  { value: 'All Pay', label: 'All Pay' },
  { value: 'e-Wallet', label: 'e-Wallet' },
  { value: 'Others', label: 'Others' }
];
export const platformType = [
  { value: 'Ecommerce only', label: 'Ecommerce' },
  { value: 'Ecommerce & store', label: 'EcommerceAndStore' },
];

export const IndustryTypes = [
  { value: 'Lifestyle', label: 'Lifestyle' },
  { value: 'Medical', label: 'Medical' },
  { value: 'Food', label: 'Food' },
  { value: 'Travel', label: 'Travel' },
  { value: 'Household', label: 'Household' },
  { value: 'Entertainment', label: 'Entertainment' },
  { value: 'Others', label: 'Others' },
];
export const LegalEntityTypes = [
  { value: 'Sole Proprietorship', label: 'Sole Proprietorship' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'Public Corporation', label: 'Public Corporation' },
  { value: 'Private Corporation', label: 'Private Corporation' },
  { value: 'Cooperative', label: 'Cooperative' },
  { value: 'Others', label: 'Others' },
];
export const attachmentsTypes = {
  merchantOnbaording: 'merchant-onboarding',
  business: 'business-onboarding'
};
export const existingSchemeOptions = [
  { label: "SGQR", value: "SGQR" },
  { label: "PayNow", value: "payNow" },
  { label: "NETS", value: "NETS" },
  { label: "Credit Cards", value: "creditCards" },
  { label: "Ali Pay", value: "aliPay" },
  { label: "e-Wallet", value: "e-Wallet" },
  { label: "Others", value: "others" },
];

export const labelOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const iBoardRequiredOptions = [
  { label: "Merchant Mobile App", value: "merchantMobileApp" },
  { label: "Web: merchant.flexm.com", value: "merchant.flexm.com" }
];


export const merchantContactRoles = [
  { value: 'shareholder', label: "Shareholder" },
  { value: 'director', label: "Director" },
  { value: 'ap', label: "Authorised Representative" },
];

export const merchantContactLabel = {
  shareholder: 'shareholder',
  director: 'director',
  authRepresentative: 'ap'
}
export const shareholderType = [
  { value: 'individual', label: 'Individual' },
  { value: 'non_individual', label: 'Non Individual' }
];
export const userStatusIn = [UserStatus.Active, UserStatus.Blocked, UserStatus.ClosureRequested, UserStatus.Deleted, UserStatus.InActive, UserStatus.UnFlagged, UserStatus.InReview];

export const userAccessTypeOptions = [
  { label: "Location Manager", value: "locationManager" },
  { label: "Location User", value: "locationUser" },
  { label: "Admin User", value: "adminUser" },
];

export const userAccessType = {
  locationManager: 'locationManager',
  locationUser: 'locationUser',
  adminUser: 'adminUser'
};
export const userAccessTypeText = {
  locationManager: 'Location Manager',
  locationUser: 'Location User',
  adminUser: 'Admin User'
};
export const settlementType = [
  { label: "Consolidated", value: "merchant" },
  { label: "Location", value: "location" },
];
export const gstRegisteredOption = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" }
];
export const CompanyDocType = [
  { value: 'ACRA', label: 'ACRA' },
  { value: 'Others', label: 'Others' }
];
export const CompanyCanadaDocType = [
  { value: 'COI', label: 'COI' },
  { value: 'Others', label: 'Others' }
];
export const OnboardedStatus = {
  Active: "active",
  Production: "production",
  ReadyForActivation: "ready-for-activation",
  Dormant: "dormant",
  InActive: "inactive",
  Closed: 'closed',
  Requested: 'requested',
  Created: 'created'

};
export const OnboardedStatusText = {

  Active: 'Active',
  InActive: 'In Active',
  Production: 'Production',
  ReadyForActivation: 'Ready For Activation',
  Dormant: 'Dormant',
  Closed: 'Closed',
  Requested: 'Requested',
  Created: 'Created'
};
export const OnboardedStatusColor = {

  Requested: 'geekblue',
  Created: 'blue',
  Production: 'cyan',
  ReadyForActivation: 'gold',
  Active: 'green',
  Dormant: 'geekblue',
  InActive: 'red',
  Closed: 'red',
};

export const onboardingStatusOptions = [

  { value: "created", label: "Created" },
  { value: "requested", label: "Requested" },
  { value: "production", label: "Production" },
  { value: "ready-for-activation", label: "Ready For Activation" },
  { value: "active", label: "Active" },
  { value: "dormant", label: "Dormant" },
  { value: "inactive", label: "InActive" },
  { value: "closed", label: "Closed" },
];

export const onboardingStatusForBulkQR = [
  { value: 12, label: "Created" },
  { value: 11, label: "Requested" },
  { value: 17, label: "Production" },
  { value: 8, label: "Ready For Activation" },
  { value: 1, label: "Active" },
  { value: 9, label: "Dormant" },
  { value: 2, label: "InActive" },
  { value: 13, label: "Closed" },
]

export const ProviderMerchantStatus = {
  Active: 1,
  InActive: 2,
  Production: 7,
  ReadyForActivation: 8,
  Dormant: 9,
  Requested: 11,
  Created: 12,
  Closed: 13
}
export const ProviderMerchantStatusText = {

  Active: 'Active',
  InActive: 'In Active',
  Production: 'Production',
  ReadyForActivation: 'Ready For Activation',
  Dormant: 'Dormant',
  Closed: 'Closed',
  Requested: 'Requested',
  Created: 'Created'
}

export const ProviderMerchantStatusColor = {

  Requested: 'geekblue',
  Created: 'blue',
  Production: 'cyan',
  ReadyForActivation: 'gold',
  Active: 'green',
  Dormant: 'geekblue',
  InActive: 'red',
  Closed: 'red',
}
export const ProviderMerchantStatusOptions = [

  { value: 11, label: 'Requested' },
  { value: 12, label: "Created" },
  { value: 7, label: "Production" },
  { value: 8, label: "Ready For Activation" },
  { value: 1, label: "Active" },
  { value: 2, label: "In Active" },
  { value: 13, label: "Closed" },
  { value: 9, label: "Dormant" },

];

export const onboardingTabs = {
  authPerson: 'authPerson',
  director: 'director',
  financeAndBilling: 'financeAndBilling',
  location: 'location',
  merchant: 'merchant',
  onlineStore: 'onlineStore',
  sendKyc: 'sendKyc',
  serviceAndPricing: 'serviceAndPricing',
  shareholder: 'shareholder',
  signature: 'signature',
  termsAndConditions: 'termsAndConditions',
  uploadFiles: 'uploadFiles',
  preview: 'preview'
}
export const RemittanceTransactionOptions = [
  { value: "id", label: "ID" },
  { value: "documentNumber", label: "Document No" },
  { value: "mobile_no", label: "Mobile No" },
  { value: "account_no", label: "Account No" },
  { value: "ttNumber", label: "TT No" },
];

export const RemittanceTransactionText = {
  id: 'id',
  documentNumber: 'documentNumber',
  mobile_no: 'mobile_no',
  account_no: 'account_no',
  ttNumber: 'ttNumber',
};
export const OnboardHistoryDocument = {
  notsubmitted: "notsubmitted",
  submitted: "submitted",
  incomplete: "incomplete",
  approved: "approved",
  reviewed: "reviewed",
};

export const OnboardHistoryDocumentText = {
  notsubmitted: "Not Submitted",
  submitted: "Submitted",
  incomplete: "Incomplete",
  approved: "Approved",
  reviewed: "Reviewed",
};
export const OnboardHistoryDocumentColor = {
  notsubmitted: "blue",
  submitted: "cyan",
  incomplete: "purple",
  approved: "green",
  reviewed: "orange",
};
export const merchantStatusType = {
  document: 'document',
  onboarded: 'onboarded',
};
export const UserRoleTexts = {
  "kyc-board-user": 'Compliance Team',
  admin: 'CS TEAM',
  merchant: 'Merchant'
}
export const StatusType = [
  { value: 'document', label: 'Document Status' },
  { value: 'onboarded', label: 'Merchant Status' },
  { value: 'kyc', label: 'KYC Status' }
];
export const transactionStatusIn = {
  orderCreated: "Order Created",
  orderAccepted: "Order Accepted",
  orderPending: "Order Pending",
  orderDelivered: "Order Delivered",
  orderRejected: "Order Rejected",
  orderCancelled: "Order Cancelled",
  orderPaymentPending: "Order Payment Pending",
  orderFailed: "Order Failed",
  orderExpired: "Order Expired",
  orderHold: "Order Hold",
  orderPaymentReceived: "Order Payment Received",
};

export const DocumentStatus = {
  notSent: 'notSent',
  sent: 'sent',
  completed: 'completed',
};

export const DocumentStatusText = {
  notSent: 'Not Sent',
  sent: 'Sent',
  completed: 'Completed',
};

export const DocumentStatusColor = {
  notSent: 'red',
  sent: 'cyan',
  completed: 'green',
};
export const TopupValueType = [
  { value: "Card", label: "Card" },
  { value: "PayNow", label: "PayNow" },
  { value: "7-11", label: "7-11" }
];
export const AccountType = [
  { value: "WALLET", label: "Wallet" },
  { value: "VIRTUAL", label: "Virtual" },
];
export const ModeType = [
  { value: "include", label: "Include" },
  { value: "exclude", label: "Exclude" },
];
export const SubscriptionPaymentInterval = [
  { value: "Monthly", label: "Monthly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "HalfYearly", label: "HalfYearly" },
  { value: "Annually", label: "Annually" },
];
export const TransactionListTypeOption = [
  { label: "Topup", value: 1 },
  { label: "Receive", value: 2 },
  { label: "Refund", value: 3 },
  { label: "Send", value: 4 }, // 'Payment to Merchant'
  { label: "Pay", value: 5 },
  { label: "Remittance", value: 6 },
  { label: "Domestic Remittance", value: 7 },
  { label: "Bill Pay", value: 8 },
  { label: "Fees", value: 9 },
  { label: "Transfer Fee", value: 11 },
];
export const TransactionListType = {
  Topup: 1,
  Receive: 2,
  Refund: 3,
  Send: 4,//'Payment to Merchant'
  Pay: 5,
  Remittance: 6,
  DomesticRemittance: 7,
  BillPay: 8,
  Fees: 9,
  TransferFee: 11,
}
export const TransactionListTypesText = {
  Topup: "Topup",
  Receive: "Receive",
  Refund: "Refund",
  Send: "Send",
  Pay: "Pay",
  Remittance: "Remittance",
  DomesticRemittance: "Domestic Remittance",
  BillPay: "Bill Pay",
  Fees: "Fees",
  TransferFee: "Transfer Fee",
};
export const TransactionListTypesColor = {
  Topup: "blue",
  Receive: "geekblue",
  Refund: "red",
  Send: "purple",
  Pay: "green",
  Remittance: "orange",
  DomesticRemittance: "geekblue",
  BillPay: "purple",
  Fees: 'cyan',
  TransferFee: 'gold',
};

export const betaEditOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const TabIndex = {
  merchant: 0,
  shareholder: 1,
  director: 2,
  authPerson: 3,
  location: 4,
  onlineStore: 5,
  financeAndBilling: 6,
  uploadFiles: 7,
  sendKyc: 8,
  serviceAndPricing: 9,
  termsAndConditions: 10,
  signature: 11,
  preview: 12
}

export const betaVersionModuleName = 'Beta Versions';

export const OnboardedMerchantCurrencies = {
  SGD: "SGD",
  PHP: "PHP",
  CAD: "CAD"
}

export const existingSchemeCanada = [
  { value: 'Credit Card', label: 'Credit Card' },
  { value: 'Debit Card', label: 'Debit Card' },
  { value: 'e-transfer', label: 'e-transfer' }
];

export const DirectorDocumentCanadaType = [
  { value: 'SIC', label: 'SIC' },
  { value: 'Passport cum Local Address Proof', label: 'Passport cum Local Address Proof' }
];

export const existingOutletSchemesSingapore = [
  { value: 'SGQR', label: 'SGQR' },
  { value: 'PayNow', label: 'PayNow' },
  { value: 'NETS', label: 'NETS' },
  { value: 'Credit Cards', label: 'Credit Cards' },
  { value: 'All Pay', label: 'All Pay' },
  { value: 'e-Wallet', label: 'e-Wallet' },
  { value: 'Others', label: 'Others' }
];
export const existingOutletSchemesCanada = [
  { value: 'FlexM QR Code', label: ' FlexM QR Code' },
  { value: 'PayNow', label: 'PayNow' },
  { value: 'NETS', label: 'NETS' },
  { value: 'Credit Cards', label: 'Credit Cards' },
  { value: 'All Pay', label: 'All Pay' },
  { value: 'e-Wallet', label: 'e-Wallet' },
  { value: 'Others', label: 'Others' }
];
export const documentUploadCanadaType = [
  { value: 'Company ID -  Certificate of Incorporation', label: 'Company ID -  Certificate of Incorporation' },
  { value: 'Compant ID - Certificate of active corporate status', label: 'Compant ID - Certificate of active corporate status' },
  { value: 'Company ID - corporations published annual report signed by an audit firm', label: 'Company ID - corporations published annual report signed by an audit firm' },
  { value: 'Company ID - A letter or notice of assessment for the corporation from a municipal, provincial, territorial or federal government', label: 'Company ID - A letter or notice of assessment for the corporation from a municipal, provincial, territorial or federal government' },
  { value: 'Individual Address Prroof - Telephone Bill', label: ' Individual Address Prroof - Telephone Bill' },
  { value: 'Individual Address Proof - Utility Bill', label: 'Individual Address Proof - Utility Bill' },
  { value: 'Individual Address Proof - Bank Statement', label: 'Individual Address Proof - Bank Statement' },
  { value: 'Individual Address Proof - Driving License', label: 'Individual Address Proof - Driving License' },
  { value: 'Additional ID proof - if required ', label: 'Additional ID proof - if required' },
  { value: 'Others', label: 'Others' }
];
export const DocumentUploadType = [
  { value: 'Latest of Co. Registration Certificate', label: 'Latest of Co. Registration Certificate' },
  { value: 'Latest of Co. Registration Certificate of shareholder company"', label: 'Latest of Co. Registration Certificate of shareholder company' },
  { value: 'SGQR', label: 'SGQR' },
];
export const gstColumnName = {
  gst: 'FlexM GST',
  hst: 'FlexM GST / HST'
};
export const prohibitOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
];
export const prohibitText = {
  true: "Yes",
  false: "No"
};
export const prohibitTextColor = {
  true: "green",
  false: "red"
};
export const prohibit = {
  true: 'true',
  false: 'false',
};
export const fulfilmentType = [
  { label: " Delivery", value: "Delivery" },
  { label: "Instore pickup", value: "Instore pickup" },
  // { label: "Address", value: "Instore pickup" },
  { label: " Others", value: "Others" },

];

export const MerchantAccountType = [
  { value: "Savings", label: "Savings" },
  { value: "Checking", label: "Checking" }
]

export const TimeZone = [
  { value: "Pacific Time Zone", label: "Pacific Time Zone" },
  { value: "Mountain Time Zone", label: "Mountain Time Zone" },
  { value: "Central Time Zone", label: "Central Time Zone" },
  { value: "Eastern Time Zone", label: "Eastern Time Zone" },
  { value: "Atlantic Time Zone", label: "Atlantic Time Zone" },
  { value: "Newfoundland Time Zone", label: "Newfoundland Time Zone" },
]
export const onboardedKycStatus = {
  notsubmitted: 'notsubmitted',
  submitted: 'submitted',
  underreview: 'underreview',
  incomplete: 'incomplete',
  verified: 'verified',
  approved: 'approved',
  rejected: 'rejected',
  expired: 'expired',
  nearexpiry: 'nearexpiry',
  reviewed: 'reviewed',
  awaiting: 'awaiting'
};
export const onboardedKycStatusText = {
  notsubmitted: 'Not Submitted',
  submitted: 'Submitted',
  underreview: 'Under Review',
  incomplete: 'Incomplete',
  verified: 'Verified',
  approved: 'Approved',
  rejected: 'Rejected',
  expired: 'Expired',
  nearexpiry: 'Near Expiry',
  reviewed: 'Reviewed',
  awaiting: 'Awaiting'
};
export const OnboardKycStatusColor = {
  verified: 'magenta',
  rejected: 'red',
  approved: 'green',
  submitted: 'cyan',
  notsubmitted: 'blue',
  incomplete: 'purple',
  underreview: 'orange',
  expired: 'red',
  nearExpiry: 'gold',
  reviewed: 'magenta',
  awaiting: 'orange'
};

export const OnboardingCountryCode = {
  SGD: '65',
  CAD: '1'
}

///////new receipt details///////
export const billToTopup = {
  name: 'Prabhu N',
  street: 'Abc street',
  building: '123 building',
  place: 'Kochi',
  country: 'Singapore',
  pincode: '049318',
}

export const billFromTopup = {
  name: 'Flexm Pte Ltd',
  street: '16 Collyer Quay',
  building: '#13-01 Collyer Quay Centre',
  country: 'Singapore',
  pincode: '049318',
}

export const SMSCharacterStartRange = [1, 161, 307]

export const SMSCharacterEndRange = [160, 306, 459]

export const TransactionMonitoringTypes = {
  complyadvantage: 'complyadvantage',
  flexcomply: 'flexcomply'
}
export const AppCode6GMustafaPay = '12';
export const ReminderLanguage = [
  { value: 'english', label: 'English' },
  { value: 'chinese', label: 'Chinese' },
]
export const isPepOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];
export const virtualRoleList = [
  { value: 'shareholder', label: 'Shareholder' },
  { value: 'director', label: 'Director' },
  { value: 'both', label: 'Both' },
  { value: 'others', label: 'Others' },
];
export const virtualAccountType = {
  primary: '1',
  secondary: '2'
};
export const virtualAccountName = {
  primary: 'Primary'
};
export const msbList = [
  "Yes",
  "No"
];
export const accountTypes = [
  { value: 'Named', label: 'Named' },
  { value: 'Regular', label: 'Regular' },
  // { value: 'Direct Remittance', label: 'Direct Remittance'}
];
export const payTypeOptions = [
  { value: '1', label: 'PayBy' },
  { value: '2', label: 'PayOut' },
];
export const statusForpayType = [
  { value: 1, label: "Active" },
  { value: 0, label: "In Active" },
];
export const payType = {
  payBy: '1',
  payOut: '2',
};
export const payTypeName = {
  payBy: "PayBy",
  payOut: "PayOut",
};
export const businessCurrencyCode = {
  code: 'SGD',
};
export const businessKycStatusOptions = [
  { value: "notsubmitted", label: "Not Submitted" },
  { value: "submitted", label: "Submitted" },
  { value: "underreview", label: "Under Review" },
  { value: "incomplete", label: "Incomplete" },
  { value: "verified", label: "Verified" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  // { value: 'expired', label: 'Expired' },
  // { value: 'nearexpiry', label: 'Near Expiry' }

];
export const businessStatusType = [
  { value: 'document', label: 'Document Status' },
  { value: 'onboarded', label: 'Business Status' },
  { value: 'kyc', label: 'KYC Status' }
];

export const VirtualTransactionType = [
  { value: 6, label: 'Refund' },
  { value: 3, label: 'Add Money' },
  { value: 25, label: 'Send Money' },
  { value: 26, label: 'Transfer' },
  { value: 13, label: 'Remittance' },
  { value: 27, label: 'Direct Remittance' },
  { value: 28, label: 'Direct Remittance Add Money' },
  { value: 29, label: 'Fees' },
  { value: 30, label: 'Monthly Recurring Fees' },
  { value: 31, label: 'Add Monthly Recurring' },
  { value: 32, label: 'Virtual Transfer' },
  { value: 33, label: 'Setup Fees' },
  { value: 34, label: 'Add Setup Fees' },
  { value: 35, label: 'Send Money By UEN' },
  { value: 36, label: 'Send Money By QR' },
  { value: 37, label: 'Payment Collection' },
  { value: 38, label: 'Payment Settlement' },
  { value: 39, label: 'Add Money Currency Cloud' },
  { value: 40, label: 'Send Money Currency Cloud' },
  { value: 41, label: 'Send Refund' },
  { value: 42, label: 'Send Money Torkey Time' },
  { value: 43, label: 'Direct Remittance Payment Received' },
  { value: 44, label: 'Bulk Upload Cross Border Send Money' },
  { value: 45, label: 'Recovery' },
  { value: 46, label: 'Bulk Upload Domestic Send Money' },
  { value: 47, label: 'Monitoring Auto Refund' },
];

export const businessAccountPaymentOptions = [
  { value: 'Stripe', label: 'Stripe' },
  { value: 'PayNow', label: 'Pay Now' },
];

export const transactionStatusReceivedPayment = [
  { value: '7', label: 'Pending' },
  { value: '8', label: 'Failed' },
  { value: '11', label: 'Received' },
];

export const paymentStatusOptions = [
  { value: '1', label: 'Received' },
  { value: '2', label: 'Pending' },
];

export const transactionStatus = {
  PaymentPending: 7,
  Failed: 8,
  PaymentReceived: 11,
  Processing: 12,
  Paid: 15
};

export const transactionNames = [
  { id: 1, label: 'Sender Name' },
  { id: 2, label: 'Receiver Name' },
];

export const ReceiverCurrencies = [
  // { code: "USD", label: "USD" },
  // { code: "INR", label: "Indian rupee (INR)" },
  // { code: "IDR", label: "Indonesian rupiah (IDR)" },
  // { code: "BDT", label: "Bangladeshi taka (BDT)" },
  // { code: "PHP", label: "Philippine peso (PHP)" },
  // { code: "SGD", label: "Singapore dollar (SGD)" },

  { "code": "AED", "label": "United Arab Emirates Dirham (AED)" },
  { "code": "AUD", "label": "Australian Dollar (AUD)" },
  { "code": "BDT", "label": "Bangladeshi Taka (BDT)" },
  { "code": "BHD", "label": "Bahraini Dinar (BHD)" },
  { "code": "BRL", "label": "Brazilian Real (BRL)" },
  { "code": "CAD", "label": "Canadian Dollar (CAD)" },
  { "code": "CNY", "label": "Chinese Yuan (CNY)" },
  { "code": "EGP", "label": "Egyptian Pound (EGP)" },
  { "code": "EUR", "label": "Euro (EUR)" },
  { "code": "GBP", "label": "British Pound (GBP)" },
  { "code": "HKD", "label": "Hong Kong Dollar (HKD)" },
  { "code": "IDR", "label": "Indonesian Rupiah (IDR)" },
  { "code": "INR", "label": "Indian Rupee (INR)" },
  { "code": "JMD", "label": "Jamaican Dollar (JMD)" },
  { "code": "JOD", "label": "Jordanian Dinar (JOD)" },
  { "code": "KES", "label": "Kenyan Shilling (KES)" },
  { "code": "MYR", "label": "Malaysian Ringgit (MYR)" },
  { "code": "NGN", "label": "Nigerian Naira (NGN)" },
  { "code": "NPR", "label": "Nepalese Rupee (NPR)" },
  { "code": "NZD", "label": "New Zealand Dollar (NZD)" },
  { "code": "PHP", "label": "Philippine Peso (PHP)" },
  { "code": "PKR", "label": "Pakistani Rupee (PKR)" },
  { "code": "SGD", "label": "Singapore Dollar (SGD)" },
  { "code": "TRY", "label": "Turkish Lira (TRY)" },
  { "code": "UGX", "label": "Ugandan Shilling (UGX)" },
  { "code": "USD", "label": "US Dollar (USD)" },
  { "code": "VND", "label": "Vietnamese Dong (VND)" },
  { "code": "XOF", "label": "West African CFA Franc (XOF)" },
  { "code": "ZAR", "label": "South African Rand (ZAR)" }
];


export const Occupation = [
  {
    "id": 814,
    "codeId": "07",
    "codeType": "11",
    "codeName": "Agriculture forestry fisheries",
    "isActive": "true"
  },
  {
    "id": 815,
    "codeId": "08",
    "codeType": "11",
    "codeName": "Construction, manufacturing, marine",
    "isActive": "true"
  },
  {
    "id": 816,
    "codeId": "03",
    "codeType": "11",
    "codeName": "Government officials and Special Interest Organizations",
    "isActive": "true"
  },
  {
    "id": 817,
    "codeId": "99",
    "codeType": "11",
    "codeName": "Other",
    "isActive": "true"
  },
  {
    "id": 818,
    "codeId": "23",
    "codeType": "11",
    "codeName": "Professional, and related workers",
    "isActive": "true"
  },
  {
    "id": 819,
    "codeId": "15",
    "codeType": "11",
    "codeName": "Retired",
    "isActive": "true"
  },
  {
    "id": 820,
    "codeId": "05",
    "codeType": "11",
    "codeName": "Self-employed",
    "isActive": "true"
  },
  {
    "id": 821,
    "codeId": "13",
    "codeType": "11",
    "codeName": "Student",
    "isActive": "true"
  },
  {
    "id": 822,
    "codeId": "14",
    "codeType": "11",
    "codeName": "Unemployed",
    "isActive": "true"
  }
]

export const PaymentPartner = [
  { "code": 'DBS', "label": 'DBS' },
  { "code": 'currencyCloud', "label": 'Currency Cloud' },
]

